// React & Router
import React, { Component } from 'react';
import { Link, withNavigate } from 'react-router-dom';

// Axios
import axios from 'axios';

// Bootstrap Components
import {
    Container, Row, Col, Card, Offcanvas
} from 'react-bootstrap';
import Images from 'react-bootstrap/Image';

// RSuite Components
import {
    Navbar, Nav, Steps, Panel, Input, InputGroup, Button, IconButton,
    Stack, VStack, HStack, SelectPicker,
    Radio, RadioGroup, Checkbox, CheckboxGroup,
    InputNumber, Text, MaskedInput, Modal, Loader
} from 'rsuite';

// Other Libraries
import Swal from 'sweetalert2';
import $ from 'jquery';
import Cropper from 'react-easy-crop';
import moment from 'moment-timezone';

// Thai Date Picker
import { ThaiDatePicker } from 'thaidatepicker-react';

// Images
import QRcode from '../../images/lineqrcode.jpg';
import ImageSize from '../../images/user.png';
import ImageLogo from '../../images/logo512.png';

export default class FormApplyPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            logged: JSON.parse(localStorage.getItem('logged')),
            isMobile: window.innerWidth <= 768,
            content: null,
            modal: null,
            menus: null,
            image: null,
            croppedImage: ImageSize,
            croppedArea: null,
            crop: { x: 0, y: 0 },
            zoom: 1,
            rotation: 0,
            selectedConsent: { consent1: false, consent2: false },
            selectedRights: [],
            schools: [],
            ethnics: [],
            reg_province_selection: [],
            reg_amphur_selection: [],
            reg_tambon_selection: [],
            temp_province_selection: [],
            temp_amphur_selection: [],
            temp_tambon_selection: [],
            existing: '',
            old_password: '',
            new_password: '',
            confirm_password: '',
            passwordVisibility: {
                old_password: false,
                new_password: false,
                confirm_password: false
            }
        };
    }

    async componentDidMount() {
        await this.promisedSetState({ loading: true });

        const loggedData = JSON.parse(localStorage.getItem('logged'));

        if (!loggedData || loggedData.login !== 'successfully') {
            window.location.href = '/';
            return;
        }

        await this.promisedSetState({
            authHeader: {
                headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            }
        });

        await this.onRead({ mode: 'read' });

        // โหลด reference data ครั้งเดียวตอน mount
        await Promise.all([
            this.fetchProvinces(),
            this.fetchSchools(),
            this.fetchEthnics(),
            this.fetchVillages(),
        ]);

        await this.onRenderContent({ mode: 'read' });

        await this.promisedSetState({ loading: false });
    }

    onMenus = async ({ mode }) => {
        if (mode === 'open') {
            await this.promisedSetState({
                menus: <>
                    <Offcanvas
                        show={true}
                        onHide={() => this.setState({ menus: null })}
                        backdrop={true}
                        style={{ width: '300px', height: '100%' }} // Full height and custom width
                    >
                        <Offcanvas.Header closeButton style={{ backgroundColor: '#8a0a0a', color: 'white' }}>
                            <Offcanvas.Title>
                                {/* Image with 30x30 px size */}
                                <img src={ImageLogo} alt="Logo" style={{ width: '40px', height: '40px', marginRight: '10px' }} />
                                {`${this.state.login_first_name} ${this.state.login_last_name}`}
                            </Offcanvas.Title>
                        </Offcanvas.Header>

                        <Offcanvas.Body className='mt-2' style={{ padding: 4, height: '100%' }}> {/* Optional style for full height */}
                            <Nav
                                appearance="subtle"
                                active={this.state.activeKey}
                                activeKey={this.state.activeKey}
                                vertical
                            >
                                <Nav.Item
                                    eventKey="1"
                                    className='mb-2'
                                    icon={<i className="bi bi-file-earmark-person-fill"></i>}
                                    onClick={async () => {
                                        await this.onDetail({ mode: 'read', id: this.state.id })
                                        await this.onMenus({ mode: 'close' })
                                    }}
                                >
                                    {' '}ดูประวัติของฉัน
                                </Nav.Item>
                                <Nav.Item
                                    eventKey="2"
                                    className='mb-2'
                                    icon={<i className="bi bi-file-text-fill"></i>}
                                    onClick={async () => {
                                        // Check if 'existing' state is true, then run onForms() or show Swal.fire
                                        if (this.state.existing) {
                                            await this.onForms({ mode: 'read', step: 0 });  // Ensure the async function is awaited properly
                                        } else {
                                            await Swal.fire({
                                                title: "กรุณากรอกข้อมูลประวัติให้ครบถ้วน",
                                                icon: "warning",
                                                timer: 2000,
                                                timerProgressBar: true,
                                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                                            });
                                        }

                                        // Close the menu after the action is performed
                                        await this.onMenus({ mode: 'close' });
                                    }}
                                >
                                    {' '}แก้ไขประวัติของฉัน
                                </Nav.Item>
                                <Nav.Item
                                    eventKey="3"
                                    className='mb-2'
                                    icon={<i className="bi bi-person-fill-gear"></i>}
                                    onClick={async () => {
                                        await this.onEdit({ mode: 'update', id: this.state.applicant_id, reload: false })
                                    }}
                                >
                                    {' '}แก้ไขข้อมูลสมาชิก
                                </Nav.Item>
                                <Nav.Item
                                    eventKey="4"
                                    className='mb-2'
                                    icon={<i className="bi bi-key-fill"></i>}
                                    onClick={async () => {
                                        await this.promisedSetState({ old_password: '', new_password: '', confirm_password: '' }, 300);
                                        await this.onPassword({ mode: 'update', id: this.state.applicant_id });
                                    }}
                                >
                                    {' '}เปลี่ยนรหัสผ่าน
                                </Nav.Item>
                                <Nav.Item
                                    eventKey="5"
                                    className='mb-2'
                                    icon={<i className="bi bi-door-open-fill"></i>}
                                    onClick={async () => {
                                        const result = await Swal.fire({
                                            title: "คุณต้องการออกจากระบบใช่หรือไม่?",
                                            icon: "warning",
                                            showDenyButton: true,
                                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                                            denyButtonText: `<div style="font-size: 1.425rem">ยกเลิก</div>`,
                                        });

                                        if (result.isConfirmed) {
                                            localStorage.removeItem('logged');
                                            window.location.href = '/';
                                        }
                                    }}
                                >
                                    {' '}ออกจากระบบ
                                </Nav.Item>
                            </Nav>
                        </Offcanvas.Body>
                    </Offcanvas>
                </>,
            });
        } else if (mode === 'close') {
            await this.promisedSetState({
                menus: null
            })
        }
    }

    promisedSetState = (newState) => {
        return new Promise(resolve => this.setState(newState, resolve));
    };

    onRead = async ({ mode }) => {
        if (mode === 'read') {
            try {
                const { logged } = this.state;
                const statusResponse = await axios.get(`${process.env.REACT_APP_API}/status/1`, this.state.authHeader);
                const statusData = statusResponse.data;

                const applicantsResponse = await axios.post(`${process.env.REACT_APP_API}/existing`, {
                    id: logged.user.user?.id,
                    year: statusData[0].default_year,
                }, this.state.authHeader);

                const applicantsData = applicantsResponse.data;
                const isExisting = applicantsData.count > 0;

                const user = isExisting ? applicantsData : logged.user;
                const applicantData = isExisting ? applicantsResponse.data.rows[0] : {};

                const initialState = {
                    // User Login
                    login_first_name: applicantData.first_name || user.user?.first_name,
                    login_last_name: applicantData.last_name || user.user?.last_name,

                    // Status
                    status: statusData[0].status,
                    applicant_id: isExisting ? applicantData.applicant_id : user.user?.id,
                    year: statusData[0].default_year,
                    existing: isExisting,

                    // User Information
                    croppedImage: isExisting ? `${process.env.REACT_APP_UPLOAD}/${applicantData.path}` : ImageSize,
                    id: isExisting ? applicantData.id : null,
                    rights1: applicantData.rights1 || false,
                    rights2: applicantData.rights2 || false,
                    rights3: applicantData.rights3 || false,
                    rights4: applicantData.rights4 || false,
                    id_card_number: applicantData.id_card_number || user.user?.id_card_number,
                    prefix: applicantData.prefix || user.user?.prefix,
                    first_name: applicantData.first_name || user.user?.first_name,
                    last_name: applicantData.last_name || user.user?.last_name,
                    nickname: applicantData.nickname || '',
                    date_of_birth: applicantData.date_of_birth || user.user?.date_of_birth,
                    ethnicity: applicantData.ethnicity || '',
                    ethnicity_other: applicantData.ethnicity_other || '',
                    phone: applicantData.phone || user.user?.phone,
                    is_family_residence: applicantData.is_family_residence || 'no',
                    family_residence_rai: applicantData.family_residence_rai || 0,
                    family_residence_ngan: applicantData.family_residence_ngan || 0,
                    family_residence_wah: applicantData.family_residence_wah || 0,
                    is_family_work: applicantData.is_family_work || 'no',
                    family_work_rai: applicantData.family_work_rai || 0,
                    family_work_ngan: applicantData.family_work_ngan || 0,
                    family_work_wah: applicantData.family_work_wah || 0,
                    is_none_residence: applicantData.is_none_residence || 'no',
                    none_residence_rai: applicantData.none_residence_rai || 0,
                    none_residence_ngan: applicantData.none_residence_ngan || 0,
                    none_residence_wah: applicantData.none_residence_wah || 0,
                    is_none_work: applicantData.is_none_work || 'no',
                    none_work_rai: applicantData.none_work_rai || 0,
                    none_work_ngan: applicantData.none_work_ngan || 0,
                    none_work_wah: applicantData.none_work_wah || 0,
                    edu_level: applicantData.edu_level || '',
                    curr_institution: applicantData.curr_institution || '',
                    curr_field: applicantData.curr_field || '',
                    grades: applicantData.grades || 0,
                    next_institution: applicantData.next_institution || '',
                    next_field: applicantData.next_field || '',
                    app_status: applicantData.app_status || '',
                    contactable: applicantData.contactable || '',
                    relationship_to_applicant: applicantData.relationship_to_applicant || '',
                    parent_status: applicantData.parent_status || 'บิดา มารดาอยู่ด้วยกัน',
                    parent_status_1: applicantData.parent_status_1 || '',
                    parent_status_2: applicantData.parent_status_2 || '',
                    parent_status_3: applicantData.parent_status_3 || '',
                    parent_status_4: applicantData.parent_status_4 || '',
                    total_siblings: applicantData.total_siblings || 0,
                    working_siblings: applicantData.working_siblings || 0,
                    siblings_in_school: applicantData.siblings_in_school || 0,
                    unemployed_siblings: applicantData.unemployed_siblings || 0,
                    siblings_not_of_age: applicantData.siblings_not_of_age || 0,
                    family_income_per_year: applicantData.family_income_per_year || 0,
                    provider_full_name: applicantData.provider_full_name || '',
                    provider_relationship: applicantData.provider_relationship || '',
                    doitung_activities: applicantData.doitung_activities || '',
                    school_activities: applicantData.school_activities || '',
                    other_activities: applicantData.other_activities || '',
                    applicant_proj_no: applicantData.applicant_proj_no || 'คพต.พ _-__-____',
                    father_proj_no: applicantData.father_proj_no || 'คพต.พ _-__-____',
                    mother_proj_no: applicantData.mother_proj_no || 'คพต.พ _-__-____',
                    is_linegroup: false,

                    // Address
                    is_reg_address: applicantData.is_reg_address || 'yes',
                    reg_house_number: applicantData.reg_house_number || user.user?.house_number,
                    reg_village_no: applicantData.reg_village_no || user.user?.village_no,
                    reg_village: applicantData.reg_village || user.user?.village,
                    reg_village_name: applicantData.reg_village_name || user.user?.village_name,
                    reg_province: applicantData.reg_province || user.user?.province,
                    reg_province_id: applicantData.reg_province_id || user.user?.province_id,
                    reg_amphur: applicantData.reg_amphur || user.user?.amphur,
                    reg_amphur_id: applicantData.reg_amphur_id || user.user?.amphur_id,
                    reg_tambon: applicantData.reg_tambon || user.user?.tambon,
                    reg_tambon_id: applicantData.reg_tambon_id || user.user?.tambon_id,
                    temp_house_number: applicantData.temp_house_number || '',
                    temp_village_no: applicantData.temp_village_no || '',
                    temp_village: applicantData.temp_village || '',
                    temp_village_name: applicantData.temp_village_name || '',
                    temp_province: applicantData.temp_province || '',
                    temp_province_id: applicantData.temp_province_id || 0,
                    temp_amphur: applicantData.temp_amphur || '',
                    temp_amphur_id: applicantData.temp_amphur_id || 0,
                    temp_tambon: applicantData.temp_tambon || '',
                    temp_tambon_id: applicantData.temp_tambon_id || 0,

                    // Family details
                    father_full_name: applicantData.father_full_name || '',
                    father_age: applicantData.father_age || '',
                    father_occupation: applicantData.father_occupation || '',
                    father_workplace: applicantData.father_workplace || '',
                    father_phone: applicantData.father_phone || '',
                    mother_full_name: applicantData.mother_full_name || '',
                    mother_age: applicantData.mother_age || '',
                    mother_occupation: applicantData.mother_occupation || '',
                    mother_workplace: applicantData.mother_workplace || '',
                    mother_phone: applicantData.mother_phone || '',

                    // Rights details
                    father_rights4: applicantData.father_rights4 || false,
                    rights_father_no: applicantData.rights_father_no || '',
                    rights_father_job_title: applicantData.rights_father_job_title || '',
                    rights_father_department: applicantData.rights_father_department || '',
                    rights_father_years: applicantData.rights_father_years || 0,
                    mother_rights4: applicantData.mother_rights4 || false,
                    rights_mother_no: applicantData.rights_mother_no || '',
                    rights_mother_job_title: applicantData.rights_mother_job_title || '',
                    rights_mother_department: applicantData.rights_mother_department || '',
                    rights_mother_years: applicantData.rights_mother_years || 0,
                };

                const rightsToCheck = ['rights1', 'rights2', 'rights3', 'rights4'];
                const promises = rightsToCheck
                    .filter(right => this.state[right])  // Only trigger changes for rights that are true
                    .map(right => this.handleRightsCheckboxChange(right));  // Call handleRightsCheckboxChange for each active right

                await Promise.all(promises);

                await this.promisedSetState(initialState);

            } catch (error) {
                console.error("Error during initialization:", error);

                // Redirect to Log In
                window.location.href = '/';
            }
        }
    }

    handleConsentCheckboxChange = async (obj) => {
        // Update the state with the checkbox name and value
        await this.promisedSetState({
            selectedConsent: {
                ...this.state.selectedConsent, // Spread the existing selectedConsent state
                [obj.name]: obj.value // Use computed property name to set the value
            }
        });

        await this.onTermsAndConditions({ mode: 'read' })
    };

    onRenderContent = async ({ mode }) => {
        if (mode === 'read') {
            const content = (
                <Container>
                    <Navbar className='shadow-sm mb-3'>
                        <Nav>
                            <Nav.Item
                                icon={<i className="bi bi-list"></i>}
                                onClick={() => this.onMenus({ mode: 'open' })}
                            >
                                <Text weight='bold'>เมนู</Text>
                            </Nav.Item>
                        </Nav>
                        <Nav pullRight>
                            <Nav.Item>
                                <HStack spacing={'6px'}>
                                    <i className="bi bi-person-circle"></i>
                                    {`${this.state.login_first_name} ${this.state.login_last_name}`}
                                </HStack>
                            </Nav.Item>
                        </Nav>
                    </Navbar>
                </Container>
            );

            await this.promisedSetState({ content });

            if (this.state.existing) {
                await this.onRights({ mode: 'read' });
            } else {
                await this.onTermsAndConditions({ mode: 'read' });
            }
        }
    };

    onTermsAndConditions = async ({ mode }) => {
        if (mode === 'read') {
            await this.promisedSetState({ loading: true })

            await this.promisedSetState({
                content: <Container>
                    <Navbar className='shadow-sm mb-3'>
                        <Nav>
                            <Nav.Item
                                icon={<i className="bi bi-list"></i>}
                                onClick={() => this.onMenus({ mode: 'open' })}
                            >
                                <Text weight='bold'>เมนู</Text>
                            </Nav.Item>
                        </Nav>
                        <Nav pullRight>
                            <Nav.Item>
                                <HStack spacing={'6px'}>
                                    <i className="bi bi-person-circle"></i>
                                    {`${this.state.login_first_name} ${this.state.login_last_name}`}
                                </HStack>
                            </Nav.Item>
                        </Nav>
                    </Navbar>
                    <Row>
                        <Col className='text-center'>
                            <Text weight="bold">
                                กรุณาอ่านข้อตกลงและเงื่อนไขให้ครบถ้วน
                            </Text>
                        </Col>
                    </Row>

                    <Row className="justify-content-center mt-3">
                        <Col md={12} lg={7}>
                            <Card border="light" className='shadow-sm'>
                                <Card.Header className='text-white' style={{ backgroundColor: '#8a0a0a' }}></Card.Header>
                                <Card.Body>
                                    <Card.Text>
                                        <CheckboxGroup name="consent">
                                            <Checkbox
                                                value="consent1"
                                                checked={this.state.selectedConsent.consent1}
                                                onChange={(e, v) => this.handleConsentCheckboxChange({ name: 'consent1', value: v })}
                                            >
                                                ด้วยการกรอกข้อมูลและนำส่งเอกสารทั้งหมดเข้ามาในใบสมัครทุนการศึกษานี้ถือว่า{' '}
                                                ผู้สมัครให้คำรับรองเกี่ยวกับความถูกต้องครบถ้วนของข้อมูล{' '}
                                                และยอมรับว่ามูลนิธิแม่ฟ้าหลวงฯ มีความจำเป็นต้องเก็บ รวบรวม{' '}
                                                และใช้ข้อมูลที่ผู้สมัครกรอกในใบสมัครและนำส่งเอกสารเข้ามา{' '}
                                                เพื่อใช้ประโยชน์ในการประเมินคุณสมบัติของผู้สมัคร{' '}
                                                ตามคุณสมบัติและเงื่อนไขการให้ทุนการศึกษาที่กำหนดไว้โดยเป็นดุลพินิจเพียงฝ่ายเดียวของมูลนิธิแม่ฟ้าหลวงฯ{' '}
                                                ในการพิจารณาให้ทุนการศึกษาและเพื่อการติดต่อประสานงานสอบถามเพิ่มเติมไปยังผู้สมัคร
                                            </Checkbox>
                                            <Checkbox
                                                value="consent2"
                                                checked={this.state.selectedConsent.consent2}
                                                onChange={(e, v) => this.handleConsentCheckboxChange({ name: 'consent2', value: v })}
                                            >
                                                ผู้สมัครยินยอมและยอมรับว่ามูลนิธิแม่ฟ้าหลวงฯ มีความเป็นต้องเก็บรวบรวมข้อมูลไว้ทั้งหมดตลอดเวลาการเปิดรับสมัคร{' '}
                                                การคัดเลือกทุนการศึกษา และอาจพิจารณาสงวนสิทธิในการเก็บข้อมูลพื้นฐานของท่าน เช่น ชื่อของผู้สมัคร เป็นต้น{' '}
                                                ไว้ต่อเนื่องแม้ท่านจะไม่ได้รับเลือกเป็นผู้รับทุนการศึกษาในครั้งนี้ เพื่อประโยชน์ในการอ้างอิงในการสมัครทุนการศึกษาครั้งหน้าของท่าน{' '}
                                            </Checkbox>
                                        </CheckboxGroup>
                                        <br />หมายเหตุ: หากท่านมีข้อสงสัยเกี่ยวกับการเก็บรวบรวมและใช้ข้อมูลส่วนต่างๆ ของท่านสามารถติดต่อมาที่เจ้าหน้าที่ทุนการศึกษา สยุมพร ศีรีนิมิต หมายเลขโทรศัพท์ 082-7581119
                                    </Card.Text>
                                    <Card.Footer style={{ backgroundColor: 'white', display: 'flex', justifyContent: 'center' }}>
                                        <Button className="me-4"
                                            color="green"
                                            appearance="primary"
                                            disabled={!this.state.selectedConsent.consent1 || !this.state.selectedConsent.consent2}
                                            onClick={() => this.onRights({ mode: 'read' })} >
                                            ยินยอม
                                        </Button>
                                        <Link to="/">
                                            <Button color="red" appearance="primary">
                                                ไม่ยินยอม
                                            </Button>
                                        </Link>
                                    </Card.Footer>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            })

            await this.promisedSetState({ loading: false })
        }
    }

    handleRightsCheckboxChange = async (value) => {
        await this.promisedSetState(prevState => {
            const { selectedRights } = prevState;
            if (selectedRights.includes(value)) {
                return { selectedRights: selectedRights.filter(right => right !== value) };
            } else {
                return { selectedRights: [...selectedRights, value] };
            }
        });

    }

    getRightDescription(right) {
        switch (right) {
            case 'rights1':
                return 'เป็นเยาวชนที่อาศัยอยู่ในพื้นที่โครงการพัฒนาดอยตุงฯ';
            case 'rights2':
                return 'เป็นเยาวชนที่อาศัยอยู่ในพื้นที่โครงการขยายผลของมูลนิธิแม่ฟ้าหลวง พระบรมราชูปถัมภ์';
            case 'rights3':
                return 'เป็นเยาวชนที่กำลังศึกษาระดับชั้นมัธยมศึกษาปีที่ 6 ในโรงเรียนบ้านห้วยไร่สามัคคี';
            case 'rights4':
                return 'เป็นบุตรพนักงานมูลนิธิแม่ฟ้าหลวงฯ (เป็นพนักงานปัจจุบัน)';
            default:
                return 'Unknown Right';
        }
    }

    onRights = async ({ mode }) => {
        if (mode === 'read') {
            await this.promisedSetState({ loading: true });

            // Collect all the selected rights
            const rightsToCheck = ['rights1', 'rights2', 'rights3', 'rights4'];

            // Filter the rights that are currently selected (i.e., true in state)
            const selectedRights = rightsToCheck.filter(right => this.state[right]);

            // Update the state with selected rights
            await this.promisedSetState({
                selectedRights: selectedRights,
            });

            // Render the content based on selected rights
            await this.promisedSetState({
                content: (
                    <Container>
                        <Navbar className='shadow-sm mb-3'>
                            <Nav>
                                <Nav.Item
                                    icon={<i className="bi bi-list"></i>}
                                    onClick={() => this.onMenus({ mode: 'open' })}
                                >
                                    <Text weight='bold'>เมนู</Text>
                                </Nav.Item>
                            </Nav>
                            <Nav pullRight>
                                <Nav.Item>
                                    <HStack spacing={'6px'}>
                                        <i className="bi bi-person-circle"></i>
                                        {`${this.state.login_first_name} ${this.state.login_last_name}`}
                                    </HStack>
                                </Nav.Item>
                            </Nav>
                        </Navbar>
                        <Row>
                            <Col className='text-center'>
                                <Text weight="bold">
                                    สิทธิ์ในการสมัครคัดเลือกทุนการศึกษา (สามารถใช้หลายสิทธิ์ได้ แต่ต้องมีข้อใดข้อหนึ่งจึงจะสมัครได้)
                                </Text>
                            </Col>
                        </Row>

                        <Row className="justify-content-center mt-3">
                            <Col md={12} lg={7}>
                                <Card border="light" className='shadow-sm'>
                                    <Card.Header className='text-white' style={{ backgroundColor: '#8a0a0a' }}></Card.Header>
                                    <Card.Body>
                                        <Card.Text>
                                            {/* Dynamically handle the checkbox values */}
                                            {rightsToCheck.map((right, index) => (
                                                <Checkbox
                                                    key={index}
                                                    value={right}
                                                    checked={this.state.selectedRights.includes(right)} // Use selectedRights for checked state
                                                    onChange={async (e, v) => {
                                                        await this.promisedSetState({ [right]: v }); // Update state dynamically
                                                        await this.handleRightsCheckboxChange(right); // Update selected rights list
                                                        await this.onRights({ mode: 'read' });
                                                    }}
                                                >
                                                    {`สิทธิ์ที่ ${index + 1} ${this.getRightDescription(right)}`}
                                                </Checkbox>
                                            ))}
                                        </Card.Text>
                                        <Card.Footer style={{ backgroundColor: 'white', display: 'flex', justifyContent: 'center' }}>
                                            <Button
                                                color="blue"
                                                appearance="primary"
                                                endIcon={<i className="bi bi-chevron-right"></i>}
                                                className="me-4"
                                                disabled={this.state.selectedRights.length === 0} // Disable if no rights are selected
                                                onClick={() => this.onForms({ mode: 'read', step: 0 })}>
                                                ถัดไป
                                            </Button>
                                        </Card.Footer>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <br />
                    </Container>
                ),
            });

            await this.promisedSetState({ loading: false });
        }
    }


    onForms = async ({ mode, step }) => {
        if (mode === 'read') {
            await this.promisedSetState({ loading: true })
            // // รอทุก fetch อิสระให้เสร็จพร้อมกัน
            // await Promise.all([
            //     this.fetchProvinces(),
            //     this.fetchSchools(),
            //     this.fetchEthnics(),
            //     this.fetchVillages(),
            // ]);

            // reg และ temp ไม่ขึ้นต่อกัน → รันพร้อมกันได้
            await Promise.all([
                this.fetchAmphures('reg_amphur_selection', 'reg_tambon_selection', this.state.reg_province_id),
                this.fetchAmphures('temp_amphur_selection', 'temp_tambon_selection', this.state.temp_province_id),
            ]);

            // Tambons ต้องรอ Amphures ของตัวเองก่อน → แยก Promise.all
            await Promise.all([
                this.fetchTambons('reg_tambon_selection', this.state.reg_amphur_id),
                this.fetchTambons('temp_tambon_selection', this.state.temp_amphur_id),
            ]);

            await this.promisedSetState({
                content: (
                    <Container>
                        <Navbar className='shadow-sm mb-3'>
                            <Nav>
                                <Nav.Item
                                    icon={<i className="bi bi-list"></i>}
                                    onClick={() => this.onMenus({ mode: 'open' })}
                                >
                                    <Text weight='bold'>เมนู</Text>
                                </Nav.Item>
                            </Nav>
                            <Nav pullRight>
                                <Nav.Item>
                                    <HStack spacing={'6px'}>
                                        <i className="bi bi-person-circle"></i>
                                        {`${this.state.login_first_name} ${this.state.login_last_name}`}
                                    </HStack>
                                </Nav.Item>
                            </Nav>
                        </Navbar>
                        <Row>
                            <Col className='text-center'>
                                <Text weight="bold">
                                    {`ใบสมัครออนไลน์สำหรับการสนับสนุนทุนการศึกษาระดับปริญญาตรี ปีการศึกษา พ.ศ. ${this.state.year}`}
                                </Text>
                            </Col>
                        </Row>

                        <Row className="justify-content-center mt-3">
                            <Col md={12} lg={12}>
                                <Card border="light" className='shadow-sm'>
                                    <Card.Header className='text-white' style={{ backgroundColor: '#8a0a0a' }}></Card.Header>
                                    <Card.Body>
                                        <Card.Text>
                                            <Steps current={step}>
                                                <Steps.Item
                                                    style={{ margin: '0.5em 0' }}
                                                    className={step !== 0 ? "hidden-on-mobile" : ""}
                                                    title="ข้อมูลทั่วไป"
                                                    icon={
                                                        step === 0 ? (
                                                            <div style={{
                                                                width: '30px',
                                                                height: '30px',
                                                                textAlign: 'center',
                                                                top: 0,
                                                                left: 0,
                                                                display: 'flex', // Using modern flexbox
                                                                alignItems: 'center',
                                                                justifyContent: 'center', // Center the icon horizontally
                                                                border: '1px solid #039be5', // You can choose to keep one of the border styles
                                                                borderRadius: '50%',
                                                                backgroundColor: '#039be5', // If you want to set a background color
                                                            }}>
                                                                <i style={{ fontSize: 20, color: 'white' }} className="bi bi-person"></i>
                                                            </div>
                                                        ) : (
                                                            <i style={{ fontSize: 20 }} className="bi bi-person"></i>
                                                        )
                                                    }
                                                />
                                                <Steps.Item
                                                    style={{ margin: '0.5em 0' }}
                                                    className={step !== 1 ? "hidden-on-mobile" : ""}
                                                    title="การเรียน"
                                                    icon={
                                                        step === 1 ? (
                                                            <div style={{
                                                                width: '30px',
                                                                height: '30px',
                                                                textAlign: 'center',
                                                                top: 0,
                                                                left: 0,
                                                                display: 'flex', // Using modern flexbox
                                                                alignItems: 'center',
                                                                justifyContent: 'center', // Center the icon horizontally
                                                                border: '1px solid #ffb300', // You can choose to keep one of the border styles
                                                                borderRadius: '50%',
                                                                backgroundColor: '#ffb300', // If you want to set a background color
                                                            }}>
                                                                <i style={{ fontSize: 20, color: 'white' }} className="bi bi-mortarboard"></i>
                                                            </div>
                                                        ) : (
                                                            <i style={{ fontSize: 20 }} className="bi bi-mortarboard"></i>
                                                        )
                                                    }
                                                />
                                                <Steps.Item
                                                    style={{ margin: '0.5em 0' }}
                                                    className={step !== 2 ? "hidden-on-mobile" : ""}
                                                    title="ครอบครัว"
                                                    icon={
                                                        step === 2 ? (
                                                            <div style={{
                                                                width: '30px',
                                                                height: '30px',
                                                                textAlign: 'center',
                                                                top: 0,
                                                                left: 0,
                                                                display: 'flex', // Using modern flexbox
                                                                alignItems: 'center',
                                                                justifyContent: 'center', // Center the icon horizontally
                                                                border: '1px solid #ec407a', // You can choose to keep one of the border styles
                                                                borderRadius: '50%',
                                                                backgroundColor: '#ec407a', // If you want to set a background color
                                                            }}>
                                                                <i style={{ fontSize: 20, color: 'white' }} className="bi bi-people"></i>
                                                            </div>
                                                        ) : (
                                                            <i style={{ fontSize: 20 }} className="bi bi-people"></i>
                                                        )
                                                    }
                                                />
                                                <Steps.Item
                                                    style={{ margin: '0.5em 0' }}
                                                    className={step !== 3 ? "hidden-on-mobile" : ""}
                                                    title="กิจกรรม"
                                                    icon={
                                                        step === 3 ? (
                                                            <div style={{
                                                                width: '30px',
                                                                height: '30px',
                                                                textAlign: 'center',
                                                                top: 0,
                                                                left: 0,
                                                                display: 'flex', // Using modern flexbox
                                                                alignItems: 'center',
                                                                justifyContent: 'center', // Center the icon horizontally
                                                                border: '1px solid #673ab7', // You can choose to keep one of the border styles
                                                                borderRadius: '50%',
                                                                backgroundColor: '#673ab7', // If you want to set a background color
                                                            }}>
                                                                <i style={{ fontSize: 20, color: 'white' }} className="bi bi-palette"></i>
                                                            </div>
                                                        ) : (
                                                            <i style={{ fontSize: 20 }} className="bi bi-palette"></i>
                                                        )
                                                    }
                                                />
                                                <Steps.Item
                                                    style={{ margin: '0.5em 0' }}
                                                    className={step !== 4 ? "hidden-on-mobile" : ""}
                                                    title="ข้อมูลเฉพาะสิทธิ์"
                                                    icon={
                                                        step === 4 ? (
                                                            <div style={{
                                                                width: '30px',
                                                                height: '30px',
                                                                textAlign: 'center',
                                                                top: 0,
                                                                left: 0,
                                                                display: 'flex', // Using modern flexbox
                                                                alignItems: 'center',
                                                                justifyContent: 'center', // Center the icon horizontally
                                                                border: '1px solid #C0C0C0', // You can choose to keep one of the border styles
                                                                borderRadius: '50%',
                                                                backgroundColor: '#C0C0C0', // If you want to set a background color
                                                            }}>
                                                                <i style={{ fontSize: 20, color: 'white' }} className="bi bi-shield-check"></i>
                                                            </div>
                                                        ) : (
                                                            <i style={{ fontSize: 20 }} className="bi bi-shield-check"></i>
                                                        )
                                                    }
                                                />
                                                <Steps.Item
                                                    style={{ margin: '0.5em 0' }}
                                                    className={step !== 5 ? "hidden-on-mobile" : ""}
                                                    title="ติดตามข่าวสาร"
                                                    icon={
                                                        step === 5 ? (
                                                            <div style={{
                                                                width: '30px',
                                                                height: '30px',
                                                                textAlign: 'center',
                                                                top: 0,
                                                                left: 0,
                                                                display: 'flex', // Using modern flexbox
                                                                alignItems: 'center',
                                                                justifyContent: 'center', // Center the icon horizontally
                                                                border: '1px solid #32CD32', // You can choose to keep one of the border styles
                                                                borderRadius: '50%',
                                                                backgroundColor: '#32CD32', // If you want to set a background color
                                                            }}>
                                                                <i style={{ fontSize: 20, color: 'white' }} className="bi bi-info-circle"></i>
                                                            </div>
                                                        ) : (
                                                            <i style={{ fontSize: 20 }} className="bi bi-info-circle"></i>
                                                        )
                                                    }
                                                />
                                            </Steps>
                                            <hr />

                                            {/* ข้อความแจ้งเตือน PDPA */}
                                            <div style={{ backgroundColor: '#f2f2f2', padding: '15px', borderRadius: '5px', marginBottom: '20px' }}>
                                                <strong>แจ้งเตือนข้อมูลความเป็นส่วนตัว (PDPA)</strong>
                                                <p style={{ marginTop: '10px', marginBottom: '0' }}>
                                                    ข้อมูลที่ท่านกรอกในแบบฟอร์มนี้ จะถูกใช้เฉพาะเพื่อคัดเลือกนักเรียนทุนเท่านั้น
                                                    และไม่นำไปใช้เพื่อวัตถุประสงค์อื่นใด ไม่ว่ากรณีใด ๆ โดยไม่ได้รับความยินยอมจากท่าน
                                                </p>
                                            </div>

                                            {step === 0 && <Panel header={`ข้อมูลทั่วไปของผู้สมัคร`}>
                                                <Row>
                                                    <Col>
                                                        <VStack>
                                                            <label>1. รูปถ่าย (รูปหน้าตรงใส่ชุดนักเรียน ขนาดรูป 1-2 นิ้ว) <span style={{ color: 'red' }}>*</span></label>
                                                            <Stack
                                                                className='cNlLu'
                                                                spacing={6}
                                                                direction={'column'}
                                                                alignItems={'flex-start'}
                                                            >
                                                                <Images
                                                                    className="border"
                                                                    src={this.state.croppedImage}
                                                                    rounded
                                                                    fluid
                                                                    width={142}
                                                                    height={198} />
                                                                <Button
                                                                    size='sm'
                                                                    color="green"
                                                                    appearance="primary"
                                                                    startIcon={<i class="bi bi-card-image"></i>}
                                                                    onClick={() => this.onSelectedImage()}>กรุณาเลือกรูปภาพ</Button>
                                                                <input
                                                                    id='InputImageUpload'
                                                                    type='file'
                                                                    accept='image/*'
                                                                    onChange={(e) => this.onSelectFile({ event: e, mode, step })}
                                                                    hidden />
                                                            </Stack>
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>2. เลขบัตรประชาชน <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='NG8dO'
                                                                size='sm'
                                                                value={this.state.id_card_number}
                                                                readOnly />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>3. คำนำหน้า <span style={{ color: 'red' }}>*</span></label>
                                                            <SelectPicker
                                                                className='J8eC9'
                                                                size='lg'
                                                                data={[
                                                                    { value: 'นาย', label: 'นาย' },
                                                                    { value: 'นางสาว', label: 'นางสาว' }
                                                                ]}
                                                                defaultValue={this.state.prefix}
                                                                searchable={false}
                                                                style={{ width: 180 }}
                                                                placeholder="กรุณาเลือกรายการ"
                                                                onChange={e => this.setState({ prefix: e })}
                                                                onClean={() => this.setState({ prefix: '' })}
                                                            />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>4. ชื่อ <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='A1bC3'
                                                                size='sm'
                                                                defaultValue={this.state.first_name}
                                                                onChange={e => this.setState({ first_name: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>5. ชื่อเล่น <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='IfAt8'
                                                                size='sm'
                                                                defaultValue={this.state.nickname}
                                                                onChange={e => this.setState({ nickname: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>6. นามสกุล <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='D4eF5'
                                                                size='sm'
                                                                defaultValue={this.state.last_name}
                                                                onChange={e => this.setState({ last_name: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>7. วัน/เดือน/ปี เกิด <span style={{ color: 'red' }}>*</span></label>
                                                            <div className='G6hI7' style={{ display: 'flex', alignItems: 'center' }}>
                                                                <ThaiDatePicker
                                                                    placeholder="วัน/เดือน/ปี พ.ศ."
                                                                    value={this.state.date_of_birth}
                                                                    inputProps={{
                                                                        style: {
                                                                            padding: '6px 8px',
                                                                            borderRadius: '6px 0 0 6px',
                                                                            border: '1px solid #E7E5E4',
                                                                            width: '200px',
                                                                        }
                                                                    }}
                                                                    onChange={async (e) => {
                                                                        await this.promisedSetState({ date_of_birth: e });
                                                                        this.onForms({ mode, step });
                                                                    }}
                                                                    onClean={async () => {
                                                                        await this.promisedSetState({ date_of_birth: '' });
                                                                        this.onForms({ mode, step });
                                                                    }}
                                                                />
                                                                <IconButton
                                                                    icon={<i className="bi bi-calendar3"></i>}
                                                                    size="md"
                                                                    style={{
                                                                        borderRadius: '0 6px 6px 0', // top-left 0, top-right 6px, bottom-right 6px, bottom-left 0
                                                                    }}
                                                                />
                                                            </div>
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>
                                                                8. ชนเผ่า <span style={{ color: 'red' }}>*</span>
                                                            </label>

                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                                <SelectPicker
                                                                    className='J8kL9'
                                                                    size='lg'
                                                                    placeholder='กรุณาเลือก'
                                                                    data={this.state.ethnics}
                                                                    style={{ width: 224 }}
                                                                    value={this.state.ethnicity}
                                                                    onChange={async value => {
                                                                        await this.promisedSetState({ ethnicity: value })

                                                                        if (value !== 'other') {
                                                                            await this.promisedSetState({ ethnicity_other: '' })
                                                                        }

                                                                        await this.onForms({ mode: mode, step: step })
                                                                    }}
                                                                    onClean={async () => {
                                                                        await this.promisedSetState({
                                                                            ethnicity: '',
                                                                            ethnicity_other: ''
                                                                        })
                                                                        await this.onForms({ mode: mode, step: step })
                                                                    }}
                                                                    cleanable
                                                                />

                                                                {this.state.ethnicity === 'อื่นๆ' && (
                                                                    <Input
                                                                        className='B8xC4'
                                                                        size='sm'
                                                                        placeholder="โปรดระบุ"
                                                                        value={this.state.ethnicity_other || ''}
                                                                        onChange={async value => {
                                                                            await this.promisedSetState({ ethnicity_other: value })
                                                                            await this.onForms({ mode: mode, step: step })
                                                                        }}
                                                                        style={{ width: 200 }}
                                                                    />
                                                                )}
                                                            </div>

                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <label className='mb-2'>9. ที่อยู่ตามทะเบียนบ้าน <span style={{ color: 'red' }}>*</span></label>
                                                    <Stack wrap spacing={10}>
                                                        <VStack>
                                                            <label>บ้านเลขที่</label>
                                                            <Input
                                                                className='M0nO1'
                                                                size='sm'
                                                                style={{ width: 90 }}
                                                                defaultValue={this.state.reg_house_number}
                                                                onChange={e => this.setState({ reg_house_number: e })} />
                                                        </VStack>
                                                        <VStack>
                                                            <label>หมู่ที่</label>
                                                            <Input
                                                                className='P2qR3'
                                                                size='sm'
                                                                style={{ width: 60 }}
                                                                defaultValue={this.state.reg_village_no}
                                                                onChange={e => this.setState({ reg_village_no: e })} />
                                                        </VStack>
                                                        <VStack>
                                                            <label>หมู่บ้าน</label>
                                                            <SelectPicker
                                                                className='S4tU5'
                                                                size='lg'
                                                                placeholder='กรุณาเลือก'
                                                                data={this.state.villages}
                                                                style={{ width: 200 }}
                                                                defaultValue={this.state.reg_village}
                                                                onChange={async e => {
                                                                    await this.promisedSetState({ reg_village: e })
                                                                    await this.onForms({ mode: mode, step: step })
                                                                }}
                                                                onClean={async e => {
                                                                    await this.promisedSetState({ reg_village: '' })
                                                                    await this.onForms({ mode: mode, step: step })
                                                                }}
                                                            />
                                                        </VStack>
                                                        {this.state.reg_village === 'other' && (
                                                            <VStack>
                                                                <label>โปรดระบุ (ชื่อหมู่บ้าน)</label>
                                                                <Input
                                                                    className='uw1NV'
                                                                    size='sm'
                                                                    style={{ width: 200 }}
                                                                    defaultValue={this.state.reg_village_name}
                                                                    onChange={e => this.setState({ reg_village_name: e })}
                                                                />
                                                            </VStack>
                                                        )}
                                                        <VStack>
                                                            <label>จังหวัด</label>
                                                            <SelectPicker
                                                                className='V6wX7'
                                                                size='lg'
                                                                placeholder='กรุณาเลือก'
                                                                data={this.state.reg_province_selection}
                                                                style={{ width: 200 }}
                                                                defaultValue={this.state.reg_province_id}
                                                                onSelect={async (v, i) => {
                                                                    await this.promisedSetState({ reg_province: i.label, reg_province_id: i.value })
                                                                    await this.handleProvinceChange({
                                                                        value: i.value,
                                                                        mode: 'read',
                                                                        step: step,
                                                                        amphureKey: 'reg_amphur_selection',
                                                                        tambonKey: 'reg_tambon_selection'
                                                                    })
                                                                }}
                                                            />
                                                        </VStack>
                                                        <VStack>
                                                            <label>อำเภอ</label>
                                                            <SelectPicker
                                                                className='Y8zA9'
                                                                size='lg'
                                                                placeholder='กรุณาเลือก'
                                                                data={this.state.reg_amphur_selection}
                                                                style={{ width: 200 }}
                                                                defaultValue={this.state.reg_amphur_id}
                                                                onSelect={async (v, i) => {
                                                                    await this.promisedSetState({ reg_amphur: i.label, reg_amphur_id: i.value })
                                                                    await this.handleAmphureChange({
                                                                        value: i.value,
                                                                        mode: 'read',
                                                                        step: step,
                                                                        tambonKey: 'reg_tambon_selection'
                                                                    })
                                                                }}
                                                            />
                                                        </VStack>
                                                        <VStack>
                                                            <label>ตำบล</label>
                                                            <SelectPicker
                                                                className='B0cD1'
                                                                size='lg'
                                                                placeholder='กรุณาเลือก'
                                                                data={this.state.reg_tambon_selection}
                                                                style={{ width: 200 }}
                                                                defaultValue={this.state.reg_tambon_id}
                                                                onSelect={async (v, i) => await this.promisedSetState({ reg_tambon: i.label, reg_tambon_id: i.value })} />
                                                        </VStack>
                                                    </Stack>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>10. ที่อยู่จริงในปัจจุบัน <span style={{ color: 'red' }}>*</span></label>
                                                            <RadioGroup
                                                                className='E2fG3'
                                                                name="is_reg_address"
                                                                defaultValue={this.state.is_reg_address}
                                                                onChange={async e => {
                                                                    await this.promisedSetState({ is_reg_address: e })
                                                                    await this.onForms({ mode: mode, step: step })
                                                                }}
                                                            >
                                                                <Radio value="yes">อาศัยอยู่ตามที่อยู่ในทะเบียนบ้าน</Radio>
                                                                <Radio value="no">ไม่ได้อาศัยอยู่ตามทะเบียนบ้าน</Radio>
                                                            </RadioGroup>

                                                            {this.state.is_reg_address === 'no' && (
                                                                <div className="mt-2">
                                                                    <Stack wrap spacing={10}>
                                                                        <VStack>
                                                                            <label>บ้านเลขที่</label>
                                                                            <Input
                                                                                className='H4iJ5'
                                                                                size='sm'
                                                                                style={{ width: 90 }}
                                                                                defaultValue={this.state.temp_house_number}
                                                                                onChange={e => this.setState({ temp_house_number: e })} />
                                                                        </VStack>
                                                                        <VStack>
                                                                            <label>หมู่ที่</label>
                                                                            <Input
                                                                                className='K6lM7'
                                                                                size='sm'
                                                                                style={{ width: 60 }}
                                                                                defaultValue={this.state.temp_village_no}
                                                                                onChange={e => this.setState({ temp_village_no: e })} />
                                                                        </VStack>
                                                                        <VStack>
                                                                            <label>หมู่บ้าน</label>
                                                                            <SelectPicker
                                                                                className='N8oP9'
                                                                                size='lg'
                                                                                placeholder='กรุณาเลือก'
                                                                                data={this.state.villages}
                                                                                style={{ width: 200 }}
                                                                                defaultValue={this.state.temp_village}
                                                                                onChange={async e => {
                                                                                    await this.promisedSetState({ temp_village: e })
                                                                                    await this.onForms({ mode: mode, step: step })
                                                                                }}
                                                                                onClean={async () => {
                                                                                    await this.promisedSetState({ temp_village: '' })
                                                                                    await this.onForms({ mode: mode, step: step })
                                                                                }}
                                                                            />
                                                                        </VStack>
                                                                        {this.state.temp_village === 'other' && (
                                                                            <VStack>
                                                                                <label>โปรดระบุ (ชื่อหมู่บ้าน)</label>
                                                                                <Input
                                                                                    className='O1aj5'
                                                                                    size='sm'
                                                                                    style={{ width: 200 }}
                                                                                    defaultValue={this.state.temp_village_name}
                                                                                    onChange={e => this.setState({ temp_village_name: e })}
                                                                                />
                                                                            </VStack>
                                                                        )}

                                                                        <VStack>
                                                                            <label>จังหวัด</label>
                                                                            <SelectPicker
                                                                                className='Q0rS1'
                                                                                size='lg'
                                                                                placeholder='กรุณาเลือก'
                                                                                data={this.state.temp_province_selection}
                                                                                style={{ width: 200 }}
                                                                                defaultValue={this.state.temp_province_id}
                                                                                onSelect={async (v, i) => {
                                                                                    await this.promisedSetState({ temp_province: i.label, temp_province_id: i.value })
                                                                                    await this.handleProvinceChange({
                                                                                        value: i.value,
                                                                                        mode: 'read',
                                                                                        step: step,
                                                                                        amphureKey: 'temp_amphur_selection',
                                                                                        tambonKey: 'temp_tambon_selection'
                                                                                    })
                                                                                }}
                                                                            />
                                                                        </VStack>
                                                                        <VStack>
                                                                            <label>อำเภอ</label>
                                                                            <SelectPicker
                                                                                className='T2uV3'
                                                                                size='lg'
                                                                                placeholder='กรุณาเลือก'
                                                                                data={this.state.temp_amphur_selection}
                                                                                style={{ width: 200 }}
                                                                                defaultValue={this.state.temp_amphur_id}
                                                                                onSelect={async (v, i) => {
                                                                                    await this.promisedSetState({ temp_amphur: i.label, temp_amphur_id: i.value })
                                                                                    await this.handleAmphureChange({
                                                                                        value: i.value,
                                                                                        mode: 'read',
                                                                                        step: step,
                                                                                        tambonKey: 'temp_tambon_selection'
                                                                                    })
                                                                                }}
                                                                            />
                                                                        </VStack>
                                                                        <VStack>
                                                                            <label>ตำบล</label>
                                                                            <SelectPicker
                                                                                className='W4xY5'
                                                                                size='lg'
                                                                                placeholder='กรุณาเลือก'
                                                                                data={this.state.temp_tambon_selection}
                                                                                style={{ width: 200 }}
                                                                                defaultValue={this.state.temp_tambon_id}
                                                                                onSelect={async (v, i) => await this.promisedSetState({ temp_tambon: i.label, temp_tambon_id: i.value })} />
                                                                        </VStack>
                                                                    </Stack>
                                                                </div>
                                                            )}
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>11. เบอร์โทรศัพท์ติดต่อส่วนตัวของผู้สมัครขอรับทุน <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='Z6aB7'
                                                                size='sm'
                                                                defaultValue={this.state.phone}
                                                                onChange={e => this.setState({ phone: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='mt-3'>
                                                        <VStack>
                                                            <span>12. ที่อยู่ (บ้าน/ที่อยู่อาศัย) ของครอบครัว <span style={{ color: 'red' }}>*</span></span>
                                                            <RadioGroup
                                                                className='C8dE9'
                                                                name="is_family_residence"
                                                                defaultValue={this.state.is_family_residence}
                                                                onChange={e => this.setState({ is_family_residence: e })} >
                                                                <Stack wrap spacing={6}>
                                                                    <Radio value="yes">มีบ้าน/ที่อยู่อาศัยเป็นของครอบครัว</Radio>
                                                                    <HStack>
                                                                        <span>จำนวน</span>
                                                                        <InputNumber
                                                                            className='F0gH1'
                                                                            size='lg'
                                                                            defaultValue={this.state.family_residence_rai}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ family_residence_rai: e })} />
                                                                        <span>ไร่</span>
                                                                    </HStack>

                                                                    <HStack>
                                                                        <InputNumber
                                                                            className='I2jK3'
                                                                            size='lg'
                                                                            defaultValue={this.state.family_residence_ngan}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ family_residence_ngan: e })} />
                                                                        <span>งาน</span>
                                                                    </HStack>

                                                                    <HStack>
                                                                        <InputNumber
                                                                            className='L4mN5'
                                                                            size='lg'
                                                                            defaultValue={this.state.family_residence_wah}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ family_residence_wah: e })} />
                                                                        <span>ตารางวา</span>
                                                                    </HStack>
                                                                </Stack>
                                                                <Stack wrap spacing={6}>
                                                                    <Radio value="no">ไม่มีบ้าน/ที่อยู่อาศัยของครอบครัว</Radio>
                                                                </Stack>
                                                            </RadioGroup>
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='mt-3'>
                                                        <VStack>
                                                            <span>13. ที่ทำกินของครอบครัว <span style={{ color: 'red' }}>*</span></span>
                                                            <RadioGroup
                                                                className='O6pQ7'
                                                                name="is_family_work"
                                                                defaultValue={this.state.is_family_work}
                                                                onChange={e => this.setState({ is_family_work: e })} >
                                                                <Stack wrap spacing={6}>
                                                                    <Radio value="yes">มีที่ทำกินเป็นของครอบครัว</Radio>
                                                                    <HStack>
                                                                        <span>จำนวน</span>
                                                                        <InputNumber
                                                                            className='R8sT9'
                                                                            size='lg'
                                                                            defaultValue={this.state.family_work_rai}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ family_work_rai: e })} />
                                                                        <span>ไร่</span>
                                                                    </HStack>

                                                                    <HStack>
                                                                        <InputNumber
                                                                            className='U0vW1'
                                                                            size='lg'
                                                                            defaultValue={this.state.family_work_ngan}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ family_work_ngan: e })} />
                                                                        <span>งาน</span>
                                                                    </HStack>

                                                                    <HStack>
                                                                        <InputNumber
                                                                            className='X2yZ3'
                                                                            size='lg'
                                                                            defaultValue={this.state.family_work_wah}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ family_work_wah: e })} />
                                                                        <span>ตารางวา</span>
                                                                    </HStack>
                                                                </Stack>
                                                                <Stack wrap spacing={6}>
                                                                    <Radio value="no">ไม่มีที่ทำกินของครอบครัว</Radio>
                                                                </Stack>
                                                            </RadioGroup>
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='mt-3'>
                                                        <VStack>
                                                            <span>14. ที่อยู่ (บ้าน/ที่อยู่อาศัย) นอกพื้นที่ <span style={{ color: 'red' }}>*</span></span>
                                                            <RadioGroup
                                                                className='mmrlQ'
                                                                name="is_none_residence"
                                                                defaultValue={this.state.is_none_residence}
                                                                onChange={e => this.setState({ is_none_residence: e })} >
                                                                <Stack wrap spacing={6}>
                                                                    <Radio value="yes">มีบ้าน/ที่อยู่อาศัยเป็นของครอบครัว</Radio>
                                                                    <HStack>
                                                                        <span>จำนวน</span>
                                                                        <InputNumber
                                                                            className='atnav'
                                                                            size='lg'
                                                                            defaultValue={this.state.none_residence_rai}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ none_residence_rai: e })} />
                                                                        <span>ไร่</span>
                                                                    </HStack>

                                                                    <HStack>
                                                                        <InputNumber
                                                                            className='f3IZU'
                                                                            size='lg'
                                                                            defaultValue={this.state.none_residence_ngan}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ none_residence_ngan: e })} />
                                                                        <span>งาน</span>
                                                                    </HStack>

                                                                    <HStack>
                                                                        <InputNumber
                                                                            className='R0ycY'
                                                                            size='lg'
                                                                            defaultValue={this.state.none_residence_wah}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ none_residence_wah: e })} />
                                                                        <span>ตารางวา</span>
                                                                    </HStack>
                                                                </Stack>
                                                                <Stack wrap spacing={6}>
                                                                    <Radio value="no">ไม่มีบ้าน/ที่อยู่อาศัยของครอบครัว</Radio>
                                                                </Stack>
                                                            </RadioGroup>
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='mt-3'>
                                                        <VStack>
                                                            <span>15. ที่ทำกินของนอกพื้นที่ <span style={{ color: 'red' }}>*</span></span>
                                                            <RadioGroup
                                                                className='jWsv5'
                                                                name="is_none_work"
                                                                defaultValue={this.state.is_none_work}
                                                                onChange={e => this.setState({ is_none_work: e })} >
                                                                <Stack wrap spacing={6}>
                                                                    <Radio value="yes">มีที่ทำกินเป็นนอกพื้นที่</Radio>
                                                                    <HStack>
                                                                        <span>จำนวน</span>
                                                                        <InputNumber
                                                                            className='R8sT9'
                                                                            size='lg'
                                                                            defaultValue={this.state.none_work_rai}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ none_work_rai: e })} />
                                                                        <span>ไร่</span>
                                                                    </HStack>

                                                                    <HStack>
                                                                        <InputNumber
                                                                            className='8EXb6'
                                                                            size='lg'
                                                                            defaultValue={this.state.none_work_ngan}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ none_work_ngan: e })} />
                                                                        <span>งาน</span>
                                                                    </HStack>

                                                                    <HStack>
                                                                        <InputNumber
                                                                            className='ntj1g'
                                                                            size='lg'
                                                                            defaultValue={this.state.none_work_wah}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ none_work_wah: e })} />
                                                                        <span>ตารางวา</span>
                                                                    </HStack>
                                                                </Stack>
                                                                <Stack wrap spacing={6}>
                                                                    <Radio value="no">ไม่มีที่ทำกินของครอบครัว</Radio>
                                                                </Stack>
                                                            </RadioGroup>
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                            </Panel>}
                                            {step === 1 && <Panel header={`ข้อมูลการเรียนของผู้สมัคร`}>
                                                <Row>
                                                    <Col>
                                                        <Stack wrap spacing={6}>
                                                            <label>1. ระดับการศึกษาที่ศึกษาอยู่ <span style={{ color: 'red' }}>*</span></label>
                                                            <SelectPicker
                                                                className='6RSoG'
                                                                size='lg'
                                                                data={[
                                                                    { value: 'มัธยมศึกษาปีที่ 6', label: 'มัธยมศึกษาปีที่ 6' },
                                                                    { value: 'ประกาศนียบัตรวิชาชีพ (ปวช.) ปีที่ 3', label: 'ประกาศนียบัตรวิชาชีพ (ปวช.) ปีที่ 3' },
                                                                    { value: 'ประกาศนียบัตรวิชาชีพชั้นสูง (ปวส.) ปีที่ 2', label: 'ประกาศนียบัตรวิชาชีพชั้นสูง (ปวส.) ปีที่ 2' },
                                                                ]}
                                                                searchable={false}
                                                                style={{ width: 300 }}
                                                                placeholder="กรุณาเลือกรายการ"
                                                                defaultValue={this.state.edu_level}
                                                                onChange={e => this.setState({ edu_level: e })}
                                                                onClean={() => this.setState({ edu_level: '' })}
                                                            />
                                                        </Stack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>2. สถานศึกษา ณ ปัจจุบัน <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='hkpCS'
                                                                size='sm'
                                                                defaultValue={this.state.curr_institution}
                                                                onChange={e => this.setState({ curr_institution: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>3. สาย/สาขาที่เรียนในปัจจุบัน <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='ptwhS'
                                                                size='sm'
                                                                defaultValue={this.state.curr_field}
                                                                onChange={e => this.setState({ curr_field: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>4. ผลการเรียน GPAX <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='Jqmmy'
                                                                size='lg'
                                                                defaultValue={this.state.grades}
                                                                style={{ width: 160 }}
                                                                onChange={e => this.setState({ grades: e })}
                                                            />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>5. สถานศึกษาที่จะเรียนต่อ <span style={{ color: 'red' }}>*</span></label>
                                                            <SelectPicker
                                                                className='1Pxg2'
                                                                size='lg'
                                                                data={this.state.schools}
                                                                style={{ width: '100%' }}
                                                                placeholder="กรุณาเลือกรายการ"
                                                                defaultValue={this.state.next_institution}
                                                                onChange={e => this.setState({ next_institution: e })}
                                                                onClean={() => this.setState({ next_institution: '' })}
                                                            />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>6. สาย/สาขาที่จะเรียนต่อ <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='coZ10'
                                                                size='sm'
                                                                defaultValue={this.state.next_field}
                                                                onChange={e => this.setState({ next_field: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>7. สถานะการสมัครเรียนในมหาวิทยาลัย <span style={{ color: 'red' }}>*</span></label>
                                                            <RadioGroup
                                                                className='nYC39'
                                                                name="app_status"
                                                                defaultValue={this.state.app_status}
                                                                onChange={e => this.setState({ app_status: e })}>
                                                                <Radio value="สอบติดเรียบร้อยและยืนยันการเข้าเรียน">สอบติดเรียบร้อยและยืนยันการเข้าเรียน</Radio>
                                                                <Radio value="สอบติดเรียบร้อยแต่ยังไม่ได้ยืนยันการเข้าเรียน">สอบติดเรียบร้อยแต่ยังไม่ได้ยืนยันการเข้าเรียน</Radio>
                                                                <Radio value="รอผลประกาศการสอบเข้า">รอผลประกาศการสอบเข้า</Radio>
                                                                <Radio value="ยังไม่ได้ดำเนินการสอบ">ยังไม่ได้ดำเนินการสอบ</Radio>
                                                            </RadioGroup>
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                            </Panel>}
                                            {step === 2 && <Panel header={`ข้อมูลครอบครัวของผู้สมัคร`}>
                                                <Row>
                                                    <Col>
                                                        <VStack>
                                                            <label>1. ชื่อ-นามสกุล บิดา (ผู้ให้กำเนิด) <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='lvPX0'
                                                                size='sm'
                                                                defaultValue={this.state.father_full_name}
                                                                onChange={e => this.setState({ father_full_name: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>2. อายุบิดา <span style={{ color: 'red' }}>*</span></label>
                                                            <InputNumber
                                                                className='Z2nR8'
                                                                size='lg'
                                                                defaultValue={this.state.father_age}
                                                                onChange={e => this.setState({ father_age: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>3. อาชีพของบิดา <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='7bbc3'
                                                                size='sm'
                                                                defaultValue={this.state.father_occupation}
                                                                onChange={e => this.setState({ father_occupation: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>4. สถานที่ทำงานของบิดา <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='5Glbw'
                                                                size='sm'
                                                                defaultValue={this.state.father_workplace}
                                                                onChange={e => this.setState({ father_workplace: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>5. หมายเลขโทรศัพท์ของบิดา <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='F4SVQ'
                                                                size='sm'
                                                                defaultValue={this.state.father_phone}
                                                                onChange={e => this.setState({ father_phone: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>6. ชื่อ-นามสกุล มารดา (ผู้ให้กำเนิด) <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='iKyhX'
                                                                size='sm'
                                                                defaultValue={this.state.mother_full_name}
                                                                onChange={e => this.setState({ mother_full_name: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>7. อายุมารดา <span style={{ color: 'red' }}>*</span></label>
                                                            <InputNumber
                                                                className='IBNHp'
                                                                size='lg'
                                                                defaultValue={this.state.mother_age}
                                                                onChange={e => this.setState({ mother_age: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>8. อาชีพของมารดา <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='cLyOx'
                                                                size='sm'
                                                                defaultValue={this.state.mother_occupation}
                                                                onChange={e => this.setState({ mother_occupation: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>9. สถานที่ทำงานมารดา <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='a5lO7'
                                                                size='sm'
                                                                defaultValue={this.state.mother_workplace}
                                                                onChange={e => this.setState({ mother_workplace: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>10. หมายเลขโทรศัพท์ของมารดา <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='v2vfN'
                                                                size='sm'
                                                                defaultValue={this.state.mother_phone}
                                                                onChange={e => this.setState({ mother_phone: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>11. สถานะของบิดา มารดา <span style={{ color: 'red' }}>*</span></label>
                                                            <RadioGroup name="parent_status"
                                                                defaultValue={this.state.parent_status}
                                                                onChange={e => this.setState({ parent_status: e })} >
                                                                <Radio value="บิดา มารดาอยู่ด้วยกัน">บิดา มารดาอยู่ด้วยกัน</Radio>
                                                                <Radio value="เสียชีวิตทั้งคู่ ปัจจุบันอาศัยอยู่กับ">เสียชีวิตทั้งคู่ ปัจจุบันอาศัยอยู่กับ</Radio>
                                                                <Input
                                                                    className='dwURj'
                                                                    size='sm'
                                                                    defaultValue={this.state.parent_status_1}
                                                                    onChange={e => this.setState({ parent_status_1: e })} />
                                                                <Radio value="บิดาหรือมารดาคนใดคนหนึ่งเสียชีวิต ปัจจุบันอาศัยอยู่กับ">บิดาหรือมารดาคนใดคนหนึ่งเสียชีวิต ปัจจุบันอาศัยอยู่กับ</Radio>
                                                                <Input
                                                                    className='Go2la'
                                                                    size='sm'
                                                                    defaultValue={this.state.parent_status_2}
                                                                    onChange={e => this.setState({ parent_status_2: e })} />
                                                                <Radio value="บิดา มารดาแยกทางกัน ปัจจุบันอาศัยอยู่กับ">บิดา มารดาแยกทางกัน ปัจจุบันอาศัยอยู่กับ</Radio>
                                                                <Input
                                                                    className='VoUBJ'
                                                                    size='sm'
                                                                    defaultValue={this.state.parent_status_3}
                                                                    onChange={e => this.setState({ parent_status_3: e })} />
                                                                <Radio value="อื่นๆ โปรดระบุ">อื่นๆ โปรดระบุ</Radio>
                                                                <Input
                                                                    className='W0HZe'
                                                                    size='sm'
                                                                    defaultValue={this.state.parent_status_4}
                                                                    onChange={e => this.setState({ parent_status_4: e })} />
                                                            </RadioGroup>
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='mt-3'>
                                                        <Stack wrap spacing={6}>
                                                            <span>12. ผู้ปกครองที่สามารถติดต่อได้ <span style={{ color: 'red' }}>*</span></span>
                                                            <Input
                                                                className='wYDAd'
                                                                size='sm'
                                                                style={{ width: 220 }}
                                                                defaultValue={this.state.contactable}
                                                                onChange={e => this.setState({ contactable: e })} />
                                                            <span>ความเกี่ยวข้องกับผู้สมัคร <span style={{ color: 'red' }}>*</span></span>
                                                            <Input
                                                                className='tgWgt'
                                                                size='sm'
                                                                style={{ width: 220 }}
                                                                defaultValue={this.state.relationship_to_applicant}
                                                                onChange={e => this.setState({ relationship_to_applicant: e })} />
                                                        </Stack>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='mt-3'>
                                                        <HStack>
                                                            <span>13. จำนวนพี่น้องร่วมบิดามารดา (ไม่รวมผู้สมัคร) <span style={{ color: 'red' }}>*</span></span>
                                                            <InputNumber
                                                                className='M7j9Z'
                                                                size='lg'
                                                                defaultValue={this.state.total_siblings}
                                                                max={20}
                                                                min={0}
                                                                style={{ width: 60 }}
                                                                onChange={e => this.setState({ total_siblings: e })} />
                                                        </HStack>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='mt-3'>
                                                        <HStack>
                                                            <span>14. จำนวนพี่น้องที่ทำงานแล้ว <span style={{ color: 'red' }}>*</span></span>
                                                            <InputNumber
                                                                className='L1f3r'
                                                                size='lg'
                                                                defaultValue={this.state.working_siblings}
                                                                max={20}
                                                                min={0}
                                                                style={{ width: 60 }}
                                                                onChange={e => this.setState({ working_siblings: e })} />
                                                            <span>คน</span>
                                                        </HStack>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='mt-3'>
                                                        <HStack>
                                                            <span>15. จำนวนพี่น้องที่เรียนอยู่ <span style={{ color: 'red' }}>*</span></span>
                                                            <InputNumber
                                                                className='RxG98'
                                                                size='lg'
                                                                defaultValue={this.state.siblings_in_school}
                                                                max={20}
                                                                min={0}
                                                                style={{ width: 60 }}
                                                                onChange={e => this.setState({ siblings_in_school: e })} />
                                                            <span>คน</span>
                                                        </HStack>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='mt-3'>
                                                        <HStack>
                                                            <span>16. จำนวนพี่น้องที่ว่างงาน <span style={{ color: 'red' }}>*</span></span>
                                                            <InputNumber
                                                                className='VM5Wt'
                                                                size='lg'
                                                                defaultValue={this.state.unemployed_siblings}
                                                                max={20}
                                                                min={0}
                                                                style={{ width: 60 }}
                                                                onChange={e => this.setState({ unemployed_siblings: e })} />
                                                            <span>คน</span>
                                                        </HStack>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='mt-3'>
                                                        <HStack>
                                                            <span>17. จำนวนพี่น้องที่ยังไม่ถึงวัยเรียน <span style={{ color: 'red' }}>*</span></span>
                                                            <InputNumber
                                                                className='CczEW'
                                                                size='lg'
                                                                defaultValue={this.state.siblings_not_of_age}
                                                                max={20}
                                                                min={0}
                                                                style={{ width: 60 }}
                                                                onChange={e => this.setState({ siblings_not_of_age: e })} />
                                                            <span>คน</span>
                                                        </HStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>18. รายได้รวมต่อปีของครอบครัว (รวมรายได้ของบิดา/มารดา/พี่น้องที่ทำงานแล้ว) <span style={{ color: 'red' }}>*</span></label>
                                                            <HStack>
                                                                <InputNumber
                                                                    className='oCbgK'
                                                                    size='lg'
                                                                    defaultValue={this.state.family_income_per_year}
                                                                    min={0}
                                                                    formatter={this.to2decimal}
                                                                    style={{ width: 180 }}
                                                                    onChange={e => this.setState({ family_income_per_year: e })}
                                                                />
                                                                <span>บาท/ปี</span>
                                                            </HStack>
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <label>19. ผู้ที่สนับสนุนค่าใช้จ่ายในชีวิตประจำวัน/ค่าใช้จ่ายในการเรียนของผู้สมัคร <span style={{ color: 'red' }}>*</span></label>
                                                        <VStack className='mt-2'>
                                                            <span>ชื่อ-นามสกุล</span>
                                                            <Input
                                                                className='O54dB'
                                                                size='sm'
                                                                defaultValue={this.state.provider_full_name}
                                                                onChange={e => this.setState({ provider_full_name: e })} />
                                                        </VStack>
                                                        <VStack className='mt-2'>
                                                            <span>ความเกี่ยวข้องกับผู้สมัคร</span>
                                                            <Input
                                                                className='K3ax9'
                                                                size='sm'
                                                                defaultValue={this.state.provider_relationship}
                                                                onChange={e => this.setState({ provider_relationship: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                            </Panel>}
                                            {step === 3 && <Panel header={`ข้อมูลการเข้าร่วมกิจกรรมของผู้สมัคร`}>
                                                <Row>
                                                    <Col>
                                                        <VStack>
                                                            <span>1. กิจกรรมที่เคยเข้าร่วมของมูลนิธิแม่ฟ้าหลวง ในพระบรมราชูปถัมภ์/โครงการดอยตุงฯ <span style={{ color: 'red' }}>*</span></span>
                                                            <Input
                                                                className='I2xNI'
                                                                as="textarea"
                                                                rows={3}
                                                                defaultValue={this.state.doitung_activities}
                                                                onChange={e => this.setState({ doitung_activities: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <span>2. กิจกรรมที่เคยเข้าร่วมของโรงเรียน <span style={{ color: 'red' }}>*</span></span>
                                                            <Input
                                                                className='12oqZ'
                                                                as="textarea"
                                                                rows={3}
                                                                defaultValue={this.state.school_activities}
                                                                onChange={e => this.setState({ school_activities: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <span>3. กิจกรรมที่อื่นๆ ที่เคยเข้าร่วม <span style={{ color: 'red' }}>*</span></span>
                                                            <Input
                                                                className='bRS7p'
                                                                as="textarea"
                                                                rows={3}
                                                                defaultValue={this.state.other_activities}
                                                                onChange={e => this.setState({ other_activities: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                            </Panel>}
                                            {step === 4 && <Panel header={`ข้อมูลที่กรอกเพิ่มเติมเฉพาะตามสิทธิ์`}>
                                                {this.state.rights1 === true && <Row className='mb-3'>
                                                    <Col>
                                                        <span>สิทธิ์ที่ 1 เป็นเยาวชนที่อาศัยอยู่ในพื้นที่โครงการพัฒนาดอยตุงฯ <span style={{ color: 'red' }}>*</span></span>
                                                        <VStack className='mt-2'>
                                                            <span>1. เลข คพต.พ ของผู้สมัคร</span>
                                                            <MaskedInput
                                                                size='sm'
                                                                className='9J7pS mt-2'
                                                                mask={[
                                                                    'ค', 'พ', 'ต', '.', 'พ', ' ',
                                                                    /[1-9]/, // First digit (1-9)
                                                                    '-',
                                                                    /\d/, /\d/, // Two digits (00-99)
                                                                    '-',
                                                                    /\d/, /\d/, /\d/, /\d/, // Four digits (0000-9999)
                                                                ]}
                                                                guide={true}
                                                                showMask={[
                                                                    'ค', 'พ', 'ต', '.', 'พ', ' ',
                                                                    /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/
                                                                ]}
                                                                keepCharPositions={true}
                                                                style={{ letterSpacing: '0.05em' }}
                                                                placeholderChar={'_'}
                                                                defaultValue={this.state.applicant_proj_no}
                                                                onChange={e => this.setState({ applicant_proj_no: e })}
                                                            />
                                                        </VStack>
                                                        <VStack className='mt-2'>
                                                            <span>2. เลข คพต.พ ของบิดา</span>
                                                            <MaskedInput
                                                                size='sm'
                                                                className='RGucO mt-2'
                                                                mask={[
                                                                    'ค', 'พ', 'ต', '.', 'พ', ' ',
                                                                    /[1-9]/, // First digit (1-9)
                                                                    '-',
                                                                    /\d/, /\d/, // Two digits (00-99)
                                                                    '-',
                                                                    /\d/, /\d/, /\d/, /\d/, // Four digits (0000-9999)
                                                                ]}
                                                                guide={true}
                                                                showMask={[
                                                                    'ค', 'พ', 'ต', '.', 'พ', ' ',
                                                                    /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/
                                                                ]}
                                                                keepCharPositions={true}
                                                                style={{ letterSpacing: '0.05em' }}
                                                                placeholderChar={'_'}
                                                                defaultValue={this.state.father_proj_no}
                                                                onChange={e => this.setState({ father_proj_no: e })}
                                                            />
                                                        </VStack>
                                                        <VStack className='mt-2'>
                                                            <span>3. เลข คพต.พ ของมารดา</span>
                                                            <MaskedInput
                                                                size='sm'
                                                                className='GXywQ mt-2'
                                                                mask={[
                                                                    'ค', 'พ', 'ต', '.', 'พ', ' ',
                                                                    /[1-9]/, // First digit (1-9)
                                                                    '-',
                                                                    /\d/, /\d/, // Two digits (00-99)
                                                                    '-',
                                                                    /\d/, /\d/, /\d/, /\d/, // Four digits (0000-9999)
                                                                ]}
                                                                guide={true}
                                                                showMask={[
                                                                    'ค', 'พ', 'ต', '.', 'พ', ' ',
                                                                    /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/
                                                                ]}
                                                                keepCharPositions={true}
                                                                style={{ letterSpacing: '0.05em' }}
                                                                placeholderChar={'_'}
                                                                defaultValue={this.state.mother_proj_no}
                                                                onChange={e => this.setState({ mother_proj_no: e })}
                                                            />
                                                        </VStack>
                                                    </Col>
                                                </Row>}
                                                {this.state.rights4 === true && <Row>
                                                    <Col>
                                                        <span>สิทธิ์ที่ 4 เป็นบุตรพนักงานมูลนิธิแม่ฟ้าหลวงฯ (เป็นพนักงานปัจจุบัน) <span style={{ color: 'red' }}>*</span></span>
                                                        <Text muted>รายละเอียดบุคคลที่ทำงานในมูลนิธิแม่ฟ้าหลวงฯ</Text>
                                                        <Row>
                                                            <Col>
                                                                <Checkbox value="father_rights4"
                                                                    defaultChecked={this.state.father_rights4}
                                                                    onChange={async (e, v) => {
                                                                        await this.promisedSetState({ father_rights4: v })
                                                                    }}>บิดา</Checkbox>
                                                                <Row style={{ marginLeft: 25 }}>
                                                                    <Col xs={12} lg={3} className='mb-2'>
                                                                        <VStack>
                                                                            <span>รหัสพนักงาน</span>
                                                                            <Input
                                                                                className='YMsqu'
                                                                                size='sm'
                                                                                style={{ width: 180 }}
                                                                                defaultValue={this.state.rights_father_no}
                                                                                onChange={e => this.setState({ rights_father_no: e })} />
                                                                        </VStack>
                                                                    </Col>
                                                                    <Col xs={12} lg={3} className='mb-2'>
                                                                        <VStack>
                                                                            <span>ตำแหน่งงาน</span>
                                                                            <Input
                                                                                className='j1YSQ'
                                                                                size='sm'
                                                                                style={{ width: 180 }}
                                                                                defaultValue={this.state.rights_father_job_title}
                                                                                onChange={e => this.setState({ rights_father_job_title: e })} />
                                                                        </VStack>
                                                                    </Col>
                                                                    <Col xs={12} lg={3} className='mb-2'>
                                                                        <VStack>
                                                                            <span>ส่วนงาน/แผนก</span>
                                                                            <Input
                                                                                className='MoUaX'
                                                                                size='sm'
                                                                                style={{ width: 180 }}
                                                                                defaultValue={this.state.rights_father_department}
                                                                                onChange={e => this.setState({ rights_father_department: e })} />
                                                                        </VStack>
                                                                    </Col>
                                                                    <Col xs={12} lg={3} className='mb-2'>
                                                                        <VStack>
                                                                            <span>จำนวนปีที่ทำงานในมูลนิธิฯ</span>
                                                                            <HStack>
                                                                                <InputNumber
                                                                                    className='Fr7KT'
                                                                                    size='lg'
                                                                                    defaultValue={this.state.rights_father_years}
                                                                                    min={0}
                                                                                    style={{ width: 80 }}
                                                                                    onChange={e => this.setState({ rights_father_years: e })} />
                                                                                <span>ปี</span>
                                                                            </HStack>
                                                                        </VStack>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Checkbox value="mother_rights4"
                                                                    defaultChecked={this.state.mother_rights4}
                                                                    onChange={(e, v) => this.setState({ mother_rights4: v })}>มารดา</Checkbox>
                                                                <Row style={{ marginLeft: 25 }}>
                                                                    <Col xs={12} lg={3} className='mb-2'>
                                                                        <VStack>
                                                                            <span>รหัสพนักงาน</span>
                                                                            <Input
                                                                                className='Bu8fI'
                                                                                size='sm'
                                                                                style={{ width: 180 }}
                                                                                defaultValue={this.state.rights_mother_no}
                                                                                onChange={e => this.setState({ rights_mother_no: e })} />
                                                                        </VStack>
                                                                    </Col>
                                                                    <Col xs={12} lg={3} className='mb-2'>
                                                                        <VStack>
                                                                            <span>ตำแหน่งงาน</span>
                                                                            <Input
                                                                                className='gKKkV'
                                                                                size='sm'
                                                                                style={{ width: 180 }}
                                                                                defaultValue={this.state.rights_mother_job_title}
                                                                                onChange={e => this.setState({ rights_mother_job_title: e })} />
                                                                        </VStack>
                                                                    </Col>
                                                                    <Col xs={12} lg={3} className='mb-2'>
                                                                        <VStack>
                                                                            <span>ส่วนงาน/แผนก</span>
                                                                            <Input
                                                                                className='1BgFc'
                                                                                size='sm'
                                                                                style={{ width: 180 }}
                                                                                defaultValue={this.state.rights_mother_department}
                                                                                onChange={e => this.setState({ rights_mother_department: e })} />
                                                                        </VStack>
                                                                    </Col>
                                                                    <Col xs={12} lg={3} className='mb-2'>
                                                                        <VStack>
                                                                            <span>จำนวนปีที่ทำงานในมูลนิธิฯ</span>
                                                                            <HStack>
                                                                                <InputNumber
                                                                                    className='A5AP8'
                                                                                    size='lg'
                                                                                    defaultValue={this.state.rights_mother_years}
                                                                                    min={0}
                                                                                    style={{ width: 80 }}
                                                                                    onChange={e => this.setState({ rights_mother_years: e })} />
                                                                                <span>ปี</span>
                                                                            </HStack>
                                                                        </VStack>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>}
                                                {this.state.rights1 === false && this.state.rights4 === false &&
                                                    <Row>
                                                        <Col><Text>ไม่มี (กรุณาทำรายการถัดไป)</Text></Col>
                                                    </Row>
                                                }
                                            </Panel>}
                                            {step === 5 && <Panel>
                                                <Row>
                                                    <Col>
                                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                            <img src={QRcode} style={{ width: '45%', borderRadius: '8px' }} alt="Line" />
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                                                            <Text weight='bold'>ขอความร่วมมือทุกคนเข้ากลุ่มไลน์</Text>
                                                            <Text>เพื่อติดตามข่าวสารการสัมภาษณ์ ติดตามผลการคัดเลือกทุน และติดตามเรื่องการส่งเอกสารเพิ่มเติม หากเข้ากลุ่มแล้วจะขอให้นักเรียนแนะนำตัวเองด้วย ชื่อ นามสกุล ชื่อเล่น สาขาและสถาบันที่จะไปเรียนต่อ หรือหากติดปัญหาระหว่างการเข้ากลุ่ม ติดต่อเจ้าหน้าที่ได้ที่เบอร์ 0827581119 พี่หยุม</Text>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                                                            <Checkbox onChange={async (e, v) => {
                                                                await this.promisedSetState({ is_linegroup: v })
                                                                await this.onForms({ mode: mode, step: step })
                                                            }}>
                                                                <Text weight='bold' color='green'>เข้ากลุ่ม Line เรียบร้อยแล้ว</Text>
                                                            </Checkbox>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Panel>}
                                            <hr />
                                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                <Button
                                                    startIcon={<i className="bi bi-chevron-left"></i>}
                                                    onClick={() => this.onPrevious(step)}
                                                    disabled={step === 0}
                                                    style={{ marginRight: '0.5em' }}
                                                >
                                                    ย้อนกลับ
                                                </Button>

                                                {step === 5 ? (
                                                    <Button
                                                        color={this.state.existing ? 'yellow' : 'green'}
                                                        appearance="primary"
                                                        startIcon={this.state.existing ? <i class="bi bi-pencil-square"></i> : <i className="bi bi-send-fill"></i>}
                                                        disabled={!this.state.is_linegroup}
                                                        onClick={() => this.onNext({ step, existing: this.state.existing })}
                                                    >
                                                        {this.state.existing ? 'แก้ไขข้อมูล' : 'ส่งข้อมูล'}
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        appearance="primary"
                                                        endIcon={<i className="bi bi-chevron-right"></i>}
                                                        onClick={() => this.onNext({ step })}
                                                        disabled={step === 5} // Disable if step is 5 to avoid conflicts
                                                    >
                                                        ถัดไป
                                                    </Button>
                                                )}
                                            </div>
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <br />
                    </Container>
                )
            });

            await this.promisedSetState({ loading: false })
        }
    }

    onSelectedImage = () => {
        const input = document.getElementById('InputImageUpload');
        if (input) {
            input.click(); // Trigger the file input click
        }
    }

    // Crop Image
    onCropComplete = (croppedAreaPercentage, croppedAreaPixels) => {
        this.setState({ croppedArea: croppedAreaPixels });
    };

    onSelectFile = async ({ event, mode, step }) => {
        if (event.target.files && event.target.files.length > 0) {
            const reader = new FileReader();
            reader.readAsDataURL(event.target.files[0]);
            reader.onload = async () => {
                await this.promisedSetState({ image: reader.result });
                await this.onModal({ mode: 'read', step })
            };
        }
    };

    createImage = (url) => {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.onload = () => resolve(image);
            image.onerror = (error) => reject(error);
            image.crossOrigin = "anonymous"; // Handle cross-origin issues
            image.src = url;
        });
    };

    getRadianAngle(degreeValue) {
        return (degreeValue * Math.PI) / 180;
    }

    getBase64 = async (imageSrc, pixelCrop, rotation) => {
        const image = await this.createImage(imageSrc);
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const maxSize = Math.max(image.width, image.height);
        const safeArea = 2 * ((maxSize / 2) * Math.sqrt(2));

        canvas.width = safeArea;
        canvas.height = safeArea;

        ctx.translate(safeArea / 2, safeArea / 2);
        ctx.rotate(this.getRadianAngle(rotation));
        ctx.translate(-safeArea / 2, -safeArea / 2);

        ctx.drawImage(image, safeArea / 2 - image.width * 0.5, safeArea / 2 - image.height * 0.5);

        const data = ctx.getImageData(0, 0, safeArea, safeArea);

        // Adjust canvas to cropped area size
        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;

        ctx.putImageData(
            data,
            0 - safeArea / 2 + image.width * 0.5 - pixelCrop.x,
            0 - safeArea / 2 + image.height * 0.5 - pixelCrop.y
        );

        return canvas.toDataURL("image/jpeg");
    };

    async base64ToBlob(base64String, contentType = '') {
        return new Promise((resolve, reject) => {
            try {
                const byteCharacters = atob(base64String);
                const byteArrays = [];

                for (let i = 0; i < byteCharacters.length; i++) {
                    byteArrays.push(byteCharacters.charCodeAt(i));
                }

                const byteArray = new Uint8Array(byteArrays);
                const blob = new Blob([byteArray], { type: contentType });

                resolve(blob); // Return the Blob as the result of the Promise
            } catch (error) {
                reject(error); // If any error occurs, reject the promise
            }
        });
    }

    onModal = async ({ mode, step }) => {
        if (mode === 'read') {
            await this.promisedSetState({
                modal: <Modal size='md' open={true} onClose={() => this.setState({ modal: null })}>
                    <Modal.Body>
                        <div style={{ width: '100%', height: '600px' }}>
                            <Cropper
                                image={this.state.image}
                                crop={this.state.crop}
                                zoom={this.state.zoom}
                                aspect={0.8 / 1}
                                onCropChange={async (e) => {
                                    await this.promisedSetState({ crop: e })
                                    await this.onModal({ mode, step })
                                }}
                                onZoomChange={async (e) => {
                                    await this.promisedSetState({ zoom: e })
                                    await this.onModal({ mode, step })
                                }}
                                onCropComplete={async (p, a) => {
                                    await this.promisedSetState({ croppedArea: a });
                                    await this.onModal({ mode, step })
                                }}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer className='p-2'>
                        <Button
                            onClick={async () => {
                                await this.promisedSetState({ loading: true }); // Set loading state to true
                                const croppedImage = await this.getBase64(this.state.image, this.state.croppedArea, 0);
                                await this.promisedSetState({ croppedImage });
                                await this.promisedSetState({ modal: null })
                                await this.onForms({ mode: mode, step: step })
                                await this.promisedSetState({ loading: false }); // Reset loading state
                            }}
                            appearance="primary"
                            startIcon={<i className="bi bi-check2-square"></i>}>
                            ยืนยัน
                        </Button>
                        <Button
                            onClick={() => this.setState({ modal: null })}
                            appearance="subtle">
                            ยกเลิก
                        </Button>
                    </Modal.Footer>
                </Modal>
            })
        }
    }

    fetchSchools = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/schools`, this.state.authHeader);
            const data = response.data.map(school => ({
                label: school.name,  // Label for the dropdown
                value: school.name   // Value for the selection
            }));

            // Add "อื่นๆ" as the last option
            data.push({
                label: 'อื่นๆ',  // Label for the "Others" option
                value: 'อื่นๆ'   // Value for the "Others" option
            });

            await this.promisedSetState({ schools: data });
        } catch (error) {
            console.error("Error fetching schools:", error);
        }
    };

    fetchEthnics = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API}/ethnics`,
                this.state.authHeader
            );

            const data = response.data.map(ethnic => ({
                label: ethnic.name,
                value: ethnic.name
            }));

            await this.promisedSetState({ ethnics: data });

        } catch (error) {
            console.error("Error fetching ethnics:", error);
        }
    };

    fetchVillages = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/villages`, this.state.authHeader);
            const data = response.data.map(village => ({
                label: village.name, // Display name in the dropdown
                value: village.name    // Value for the selection
            }));

            // Add the "Other" option at the end of the list
            data.push({
                label: 'อื่นๆ (โปรดระบุ)',
                value: 'other'  // The value for the "Other" option
            });

            // Update the state with the villages data
            await this.promisedSetState({ villages: data });
        } catch (error) {
            console.error("Error fetching villages:", error);
        }
    };

    fetchProvinces = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/provinces`, this.state.authHeader);
            const provinces = response.data.map(province => ({
                label: province.name_th,
                value: province.id
            }));

            await this.promisedSetState({ reg_province_selection: provinces, temp_province_selection: provinces, update_provinces: provinces });

        } catch (error) {
            console.error('Error fetching provinces:', error);
        }
    };

    fetchAmphures = async (amphureKey, tambonKey, provinceId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/amphures/${provinceId}`, this.state.authHeader);
            const amphuresData = response.data.map(amphure => ({
                label: amphure.name_th,
                value: amphure.id
            }));
            await this.promisedSetState({ [amphureKey]: amphuresData, [tambonKey]: [] }); // Reset tambons
        } catch (error) {
            console.error('Error fetching amphures:', error);
        }
    };

    fetchTambons = async (tambonKey, amphureId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/tambons/${amphureId}`, this.state.authHeader);
            const tambonsData = response.data.map(tambon => ({
                label: tambon.name_th,
                value: tambon.id
            }));
            await this.promisedSetState({ [tambonKey]: tambonsData });
        } catch (error) {
            console.error('Error fetching tambons:', error);
        }
    };

    handleProvinceChange = async ({ value, mode, step, amphureKey, tambonKey, id }) => {
        try {
            await this.fetchAmphures(amphureKey, tambonKey, value);
            mode === 'update' ? await this.onEdit({ mode: mode, id: id, reload: true }) : await this.onForms({ mode: 'read', mode, step });
        } catch (error) {
            console.error('Error handling province change:', error);
        }
    };

    handleAmphureChange = async ({ value, mode, step, tambonKey, id }) => {
        try {
            await this.fetchTambons(tambonKey, value);
            mode === 'update' ? await this.onEdit({ mode: mode, id: id, reload: true }) : await this.onForms({ mode: 'read', mode, step });
        } catch (error) {
            console.error('Error handling amphure change:', error);
        }
    };

    to2decimal = (value) => {
        return `${(value * 1).toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}`
    }

    toInterger = (value) => {
        return `${(value * 1).toFixed(0).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}`
    }

    Validate = async (params, clss, cond) => {
        try {
            // Simulate an asynchronous operation (e.g., a network request or delay)
            await new Promise(resolve => setTimeout(resolve, 100)); // Simulating a 500ms delay

            if (params === cond) {
                // Add 'required' class if condition is met
                $('.' + clss).addClass("required");

                // Display an alert using SweetAlert
                Swal.fire({
                    title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                    icon: "warning",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });

                return false; // Return false if validation fails
            } else if (params !== cond) {
                // Remove 'required' class if condition is not met
                $('.' + clss).removeClass("required");

                return true; // Return true if validation passes
            }
        } catch (error) {
            console.error('Validation error:', error);
            return false; // If something goes wrong, return false as fallback
        }
    };

    onNext = async ({ step, existing }) => {

        const validateStep0 = async () => {
            // Start with an array to collect validation promises
            const validationPromises = [
                this.Validate(this.state.croppedImage, 'cNlLu', ImageSize),
                this.Validate(this.state.id_card_number, 'NG8dO', ''),
                this.Validate(this.state.prefix, 'J8eC9', ''),
                this.Validate(this.state.first_name, 'A1bC3', ''),
                this.Validate(this.state.last_name, 'D4eF5', ''),
                this.Validate(this.state.nickname, 'IfAt8', ''),
                this.Validate(this.state.date_of_birth, 'G6hI7', ''),
                this.Validate(this.state.ethnicity, 'J8kL9', ''),
                ...(this.state.ethnicity === 'อื่นๆ' ? [
                    this.Validate(this.state.ethnicity_other, 'B8xC4', ''),
                ] : []),
                this.Validate(this.state.reg_house_number, 'M0nO1', ''),
                this.Validate(this.state.reg_village_no, 'P2qR3', ''),
                this.Validate(this.state.reg_village, 'S4tU5', ''),
                this.Validate(this.state.reg_province, 'V6wX7', ''),
                this.Validate(this.state.reg_amphur, 'Y8zA9', ''),
                this.Validate(this.state.reg_tambon, 'B0cD1', ''),
                this.Validate(this.state.family_residence_rai, 'F0gH1', ''),
                this.Validate(this.state.family_residence_ngan, 'I2jK3', ''),
                this.Validate(this.state.family_residence_wah, 'L4mN5', ''),
                this.Validate(this.state.family_work_rai, 'R8sT9', ''),
                this.Validate(this.state.family_work_ngan, 'U0vW1', ''),
                this.Validate(this.state.family_work_wah, 'X2yZ3', ''),

                // Conditionally add 'reg_village_name' if 'reg_village' is 'other'
                ...(this.state.reg_village === 'other' ? [
                    this.Validate(this.state.reg_village_name, 'uw1NV', ''),
                ] : []),

                // Conditionally add temporary address validations if applicable
                ...(this.state.is_reg_address === 'no' ? [
                    this.Validate(this.state.temp_house_number, 'H4iJ5', ''),
                    this.Validate(this.state.temp_village_no, 'K6lM7', ''),
                    this.Validate(this.state.temp_village, 'N8oP9', ''),
                    ...(this.state.temp_village === 'other' ? [
                        this.Validate(this.state.temp_village_name, 'O1aj5', ''),
                    ] : []),
                    this.Validate(this.state.temp_province, 'Q0rS1', ''),
                    this.Validate(this.state.temp_amphur, 'T2uV3', ''),
                    this.Validate(this.state.temp_tambon, 'W4xY5', '')
                ] : []),

                // Validate phone number
                this.Validate(this.state.phone, 'Z6aB7', ''),
            ];

            // Wait for all validation promises to resolve
            const validationResults = await Promise.all(validationPromises);

            // Return true if all validations are successful (i.e., all are true)
            return validationResults.every(result => result === true);
        };

        const validateStep1 = async () => {
            // Start with an array of validations
            const validationPromises = [
                this.Validate(this.state.edu_level, '6RSoG', ''),
                this.Validate(this.state.curr_institution, 'hkpCS', ''),
                this.Validate(this.state.curr_field, 'ptwhS', ''),
                this.Validate(this.state.grades, 'Jqmmy', ''),
                this.Validate(this.state.next_institution, '1Pxg2', ''),
                this.Validate(this.state.next_field, 'coZ10', ''),
                this.Validate(this.state.app_status, 'nYC39', ''),
            ];

            // Wait for all validation promises to resolve
            const validationResults = await Promise.all(validationPromises);

            // Return true if all validations are successful (i.e., all are true)
            return validationResults.every(result => result === true);
        };

        const validateStep2 = async () => {
            // Start with an array of validations
            const validationPromises = [
                this.Validate(this.state.father_full_name, 'lvPX0', ''),
                this.Validate(this.state.father_age, 'Z2nR8', ''),
                this.Validate(this.state.father_occupation, '7bbc3', ''),
                this.Validate(this.state.father_workplace, '5Glbw', ''),
                this.Validate(this.state.father_phone, 'F4SVQ', ''),
                this.Validate(this.state.mother_full_name, 'iKyhX', ''),
                this.Validate(this.state.mother_age, 'IBNHp', ''),
                this.Validate(this.state.mother_occupation, 'cLyOx', ''),
                this.Validate(this.state.mother_workplace, 'a5lO7', ''),
                this.Validate(this.state.mother_phone, 'v2vfN', ''),
                this.Validate(this.state.parent_status, 'TAzlS', ''),
                // Conditionally add temporary address validation if applicable
                ...(this.state.parent_status === 'เสียชีวิตทั้งคู่ ปัจจุบันอาศัยอยู่กับ' ? [
                    this.Validate(this.state.parent_status_1, 'dwURj', ''),
                ] : []),
                ...(this.state.parent_status === 'บิดาหรือมารดาคนใดคนหนึ่งเสียชีวิต ปัจจุบันอาศัยอยู่กับ' ? [
                    this.Validate(this.state.parent_status_2, 'Go2la', ''),
                ] : []),
                ...(this.state.parent_status === 'บิดา มารดาแยกทางกัน ปัจจุบันอาศัยอยู่กับ' ? [
                    this.Validate(this.state.parent_status_3, 'VoUBJ', ''),
                ] : []),
                ...(this.state.parent_status === 'อื่นๆ โปรดระบุ' ? [
                    this.Validate(this.state.parent_status_4, 'W0HZe', ''),
                ] : []),
                this.Validate(this.state.contactable, 'wYDAd', ''),
                this.Validate(this.state.relationship_to_applicant, 'tgWgt', ''),
                this.Validate(this.state.provider_full_name, 'O54dB', ''),
                this.Validate(this.state.provider_relationship, 'K3ax9', ''),
                this.Validate(this.state.total_siblings, 'M7j9Z', ''),
                this.Validate(this.state.working_siblings, 'L1f3r', ''),
                this.Validate(this.state.siblings_in_school, 'RxG98', ''),
                this.Validate(this.state.unemployed_siblings, 'VM5Wt', ''),
                this.Validate(this.state.siblings_not_of_age, 'CczEW', ''),
                this.Validate(this.state.family_income_per_year, 'oCbgK', ''),
            ];

            // Wait for all validation promises to resolve
            const validationResults = await Promise.all(validationPromises);

            // Return true if all validations are successful (i.e., all are true)
            return validationResults.every(result => result === true);
        };

        const validateStep3 = async () => {
            // Start with an array of validations
            const validationPromises = [
                this.Validate(this.state.doitung_activities, 'I2xNI', ''),
                this.Validate(this.state.school_activities, '12oqZ', ''),
                this.Validate(this.state.other_activities, 'bRS7p', '')
            ];


            // Wait for all validation promises to resolve
            const validationResults = await Promise.all(validationPromises);

            // Return true if all validations are successful (i.e., all are true)
            return validationResults.every(result => result === true);
        };

        const validateStep4 = async () => {
            // Start with an array of validations
            const validationPromises = [
                // Conditionally add temporary address validation if applicable
                ...(this.state.rights1 === true ? [
                    this.Validate(this.state.applicant_proj_no, '9J7pS', 'คพต.พ _-__-____'),
                    this.Validate(this.state.father_proj_no, 'RGucO', ''),
                    this.Validate(this.state.mother_proj_no, 'GXywQ', ''),
                ] : []),
                ...(this.state.rights4 === true ? [
                    ...(this.state.father_rights4 === true ? [
                        this.Validate(this.state.rights_father_no, 'YMsqu', ''),
                        this.Validate(this.state.rights_father_job_title, 'j1YSQ', ''),
                        this.Validate(this.state.rights_father_department, 'MoUaX', ''),
                        // this.Validate(this.state.rights_father_years, 'Fr7KT', 0),
                    ] : []),
                    ...(this.state.mother_rights4 === true ? [
                        this.Validate(this.state.rights_mother_no, 'Bu8fI', ''),
                        this.Validate(this.state.rights_mother_job_title, 'gKKkV', ''),
                        this.Validate(this.state.rights_mother_department, '1BgFc', ''),
                    ] : []),
                ] : []),
            ];

            // Wait for all validation promises to resolve
            const validationResults = await Promise.all(validationPromises);

            // Return true if all validations are successful (i.e., all are true)
            return validationResults.every(result => result === true);
        };

        // Check validation and perform the action based on the step
        switch (step) {
            case 0:
                if (await validateStep0()) {
                    // event0: Perform your action for step 0
                    this.onForms({ mode: 'read', step: step + 1 })
                }
                break;
            case 1:
                if (await validateStep1()) {
                    // event1: Perform your action for step 1
                    this.onForms({ mode: 'read', step: step + 1 })
                }
                break;
            case 2:
                if (await validateStep2()) {
                    // event2: Perform your action for step 2
                    this.onForms({ mode: 'read', step: step + 1 })
                }
                break;
            case 3:
                if (await validateStep3()) {
                    // event3: Perform your action for step 3
                    this.onForms({ mode: 'read', step: step + 1 })
                }
                break;
            case 4:
                if (await validateStep4()) {
                    // event4: Perform your action for step 4
                    this.onForms({ mode: 'read', step: step + 1 })
                }
                break;
            case 5:
                if (this.state.is_linegroup === true) {
                    if (existing === true) {

                        await this.promisedSetState({ loading: true })

                        // Fetch data from the API
                        const responseStatus = await axios.get(`${process.env.REACT_APP_API}/status/1`, this.state.authHeader);
                        const responseYear = await axios.get(`${process.env.REACT_APP_API}/default/${this.state.year}`, this.state.authHeader);

                        // Parse start_date
                        const start_date = moment.tz(`${responseYear.data.rows[0].start_date} 00:00`, 'YYYY-MM-DD HH:mm', 'Asia/Bangkok').toDate();

                        // Parse and modify end_date in one step
                        const end_date = moment.tz(`${responseYear.data.rows[0].end_date} 00:00`, 'YYYY-MM-DD HH:mm', 'Asia/Bangkok')
                            .add(1, 'minute')
                            .add(1, 'day')
                            .toDate();

                        // Check if the current date and time is between start_date and end_date
                        if (responseStatus.data[0].status && start_date && end_date && moment().tz('Asia/Bangkok').isBetween(start_date, end_date)) {
                            try {

                                const responseImage = await fetch(this.state.croppedImage);
                                const blob = await responseImage.blob();

                                const formData = new FormData();
                                formData.append('id', this.state.id);
                                formData.append('applicant_id', this.state.applicant_id);
                                formData.append('year', this.state.year);
                                formData.append('rights1', this.state.rights1);
                                formData.append('rights2', this.state.rights2);
                                formData.append('rights3', this.state.rights3);
                                formData.append('rights4', this.state.rights4);
                                formData.append('id_card_number', this.state.id_card_number);
                                formData.append('first_name', this.state.first_name);
                                formData.append('last_name', this.state.last_name);
                                formData.append('nickname', this.state.nickname);
                                formData.append('date_of_birth', this.state.date_of_birth);
                                formData.append('ethnicity', this.state.ethnicity);
                                formData.append('ethnicity_other', this.state.ethnicity_other);
                                formData.append('reg_house_number', this.state.reg_house_number);
                                formData.append('reg_village_no', this.state.reg_village_no);
                                formData.append('reg_village', this.state.reg_village);
                                formData.append('reg_village_name', this.state.reg_village_name);
                                formData.append('reg_province', this.state.reg_province);
                                formData.append('reg_province_id', this.state.reg_province_id);
                                formData.append('reg_amphur', this.state.reg_amphur);
                                formData.append('reg_amphur_id', this.state.reg_amphur_id);
                                formData.append('reg_tambon', this.state.reg_tambon);
                                formData.append('reg_tambon_id', this.state.reg_tambon_id);
                                formData.append('is_reg_address', this.state.is_reg_address);
                                formData.append('temp_house_number', this.state.temp_house_number);
                                formData.append('temp_village_no', this.state.temp_village_no);
                                formData.append('temp_village', this.state.temp_village);
                                formData.append('temp_village_name', this.state.temp_village_name);
                                formData.append('temp_province', this.state.temp_province);
                                formData.append('temp_province_id', this.state.temp_province_id);
                                formData.append('temp_amphur', this.state.temp_amphur);
                                formData.append('temp_amphur_id', this.state.temp_amphur_id);
                                formData.append('temp_tambon', this.state.temp_tambon);
                                formData.append('temp_tambon_id', this.state.temp_tambon_id);
                                formData.append('phone', this.state.phone);
                                formData.append('is_family_residence', this.state.is_family_residence);
                                formData.append('family_residence_rai', this.state.family_residence_rai);
                                formData.append('family_residence_ngan', this.state.family_residence_ngan);
                                formData.append('family_residence_wah', this.state.family_residence_wah);
                                formData.append('is_family_work', this.state.is_family_work);
                                formData.append('family_work_rai', this.state.family_work_rai);
                                formData.append('family_work_ngan', this.state.family_work_ngan);
                                formData.append('family_work_wah', this.state.family_work_wah);
                                formData.append('is_none_residence', this.state.is_none_residence);
                                formData.append('none_residence_rai', this.state.none_residence_rai);
                                formData.append('none_residence_ngan', this.state.none_residence_ngan);
                                formData.append('none_residence_wah', this.state.none_residence_wah);
                                formData.append('is_none_work', this.state.is_none_work);
                                formData.append('none_work_rai', this.state.none_work_rai);
                                formData.append('none_work_ngan', this.state.none_work_ngan);
                                formData.append('none_work_wah', this.state.none_work_wah);
                                formData.append('edu_level', this.state.edu_level);
                                formData.append('curr_institution', this.state.curr_institution);
                                formData.append('curr_field', this.state.curr_field);
                                formData.append('grades', this.state.grades);
                                formData.append('next_institution', this.state.next_institution);
                                formData.append('next_field', this.state.next_field);
                                formData.append('app_status', this.state.app_status);
                                formData.append('father_full_name', this.state.father_full_name);
                                formData.append('father_age', this.state.father_age);
                                formData.append('father_occupation', this.state.father_occupation);
                                formData.append('father_workplace', this.state.father_workplace);
                                formData.append('father_phone', this.state.father_phone);
                                formData.append('mother_full_name', this.state.mother_full_name);
                                formData.append('mother_age', this.state.mother_age);
                                formData.append('mother_occupation', this.state.mother_occupation);
                                formData.append('mother_workplace', this.state.mother_workplace);
                                formData.append('mother_phone', this.state.mother_phone);
                                formData.append('parent_status', this.state.parent_status);
                                formData.append('parent_status_1', this.state.parent_status_1);
                                formData.append('parent_status_2', this.state.parent_status_2);
                                formData.append('parent_status_3', this.state.parent_status_3);
                                formData.append('parent_status_4', this.state.parent_status_4);
                                formData.append('contactable', this.state.contactable);
                                formData.append('relationship_to_applicant', this.state.relationship_to_applicant);
                                formData.append('total_siblings', this.state.total_siblings);
                                formData.append('working_siblings', this.state.working_siblings);
                                formData.append('siblings_in_school', this.state.siblings_in_school);
                                formData.append('unemployed_siblings', this.state.unemployed_siblings);
                                formData.append('siblings_not_of_age', this.state.siblings_not_of_age);
                                formData.append('family_income_per_year', this.state.family_income_per_year);
                                formData.append('provider_full_name', this.state.provider_full_name);
                                formData.append('provider_relationship', this.state.provider_relationship);
                                formData.append('doitung_activities', this.state.doitung_activities);
                                formData.append('school_activities', this.state.school_activities);
                                formData.append('other_activities', this.state.other_activities);
                                formData.append('applicant_proj_no', this.state.applicant_proj_no);
                                formData.append('father_proj_no', this.state.father_proj_no);
                                formData.append('mother_proj_no', this.state.mother_proj_no);
                                formData.append('father_rights4', this.state.father_rights4);
                                formData.append('rights_father_no', this.state.rights_father_no);
                                formData.append('rights_father_job_title', this.state.rights_father_job_title);
                                formData.append('rights_father_department', this.state.rights_father_department);
                                formData.append('rights_father_years', this.state.rights_father_years);
                                formData.append('mother_rights4', this.state.mother_rights4);
                                formData.append('rights_mother_no', this.state.rights_mother_no);
                                formData.append('rights_mother_job_title', this.state.rights_mother_job_title);
                                formData.append('rights_mother_department', this.state.rights_mother_department);
                                formData.append('rights_mother_years', this.state.rights_mother_years);
                                formData.append('is_linegroup', this.state.is_linegroup);
                                formData.append('image', blob, 'image.png');

                                const response = await axios.patch(`${process.env.REACT_APP_API}/application`, formData, this.state.authHeader);

                                const data = response.data;

                                if (data.message === 'successfully') {

                                    const messageResponse = await axios.post(`${process.env.REACT_APP_API}/messages`, {
                                        message: `แก้ไขข้อมูลของผู้สมัครขอรับทุน!\n👤 ชื่อ: ${this.state.first_name} ${this.state.last_name} (${this.state.nickname})\n🔍 ตรวจสอบข้อมูลเพิ่มเติม: 👉 https://applyscholarship.maefahluang.org/admin/applicant/detail/${this.state.id}`
                                    });

                                    if (messageResponse.data.message === 'successfully') {

                                        await this.onRead({ mode: 'read' })

                                        await this.promisedSetState({ loading: false })

                                        Swal.fire({
                                            title: "คุณบันทึกข้อมูลเรียบร้อยแล้ว",
                                            icon: "success",
                                            timer: 2000,
                                            timerProgressBar: true,
                                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                                        }).then(async () => {
                                            // Wait for the onForms function to complete if it's async
                                            await this.onForms({ mode: 'read', step: 0 });
                                        });
                                    }
                                }
                            } catch (error) {
                                console.error('Error submitting application:', error);
                            }
                        } else {
                            Swal.fire({
                                title: "ระบบปิดรับสมัคร",
                                icon: "error",
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            });
                        }

                    } else if (existing === false) {

                        await this.promisedSetState({ loading: true })

                        const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

                        // Fetch data from the API
                        const responseStatus = await axios.get(`${process.env.REACT_APP_API}/status/1`, this.state.authHeader);
                        const responseYear = await axios.get(`${process.env.REACT_APP_API}/default/${this.state.year}`, this.state.authHeader);
                        await delay(200);

                        // Parse start_date using moment (time zone Asia/Bangkok)
                        const start_date = moment.tz(`${responseYear.data.rows[0].start_date} 00:00`, 'YYYY-MM-DD HH:mm', 'Asia/Bangkok').toDate();

                        // Parse and modify end_date in one step
                        const end_date = moment.tz(`${responseYear.data.rows[0].end_date} 00:00`, 'YYYY-MM-DD HH:mm', 'Asia/Bangkok')
                            .add(1, 'minute')
                            .add(1, 'day')
                            .toDate();

                        // Optional: Add a delay before performing the check
                        await delay(100);

                        // Wrap moment comparison in a promised function
                        const checkTimeRange = async () => {
                            const currentTime = moment().tz('Asia/Bangkok');
                            return currentTime.isBetween(start_date, end_date);
                        };

                        // Wait for the promised moment check
                        const isBetween = await checkTimeRange();

                        await delay(100);

                        // Check if the current date and time is between start_date and end_date
                        if (responseStatus.data[0].status && start_date && end_date && isBetween) {
                            try {

                                // 1. สร้างอาร์เรย์เก็บชื่อฟิลด์ทั้งหมดที่ต้อง append
                                const keys = [
                                    'applicant_id', 'year', 'rights1', 'rights2', 'rights3', 'rights4',
                                    'id_card_number', 'prefix', 'first_name', 'last_name', 'nickname', 'date_of_birth',
                                    'ethnicity', 'ethnicity_other', 'reg_house_number', 'reg_village_no', 'reg_village', 'reg_village_name',
                                    'reg_province', 'reg_province_id', 'reg_amphur', 'reg_amphur_id', 'reg_tambon', 'reg_tambon_id',
                                    'is_reg_address', 'temp_house_number', 'temp_village_no', 'temp_village', 'temp_village_name',
                                    'temp_province', 'temp_province_id', 'temp_amphur', 'temp_amphur_id', 'temp_tambon', 'temp_tambon_id',
                                    'phone', 'is_family_residence', 'family_residence_rai', 'family_residence_ngan', 'family_residence_wah',
                                    'is_family_work', 'family_work_rai', 'family_work_ngan', 'family_work_wah',
                                    'is_none_residence', 'none_residence_rai', 'none_residence_ngan', 'none_residence_wah',
                                    'is_none_work', 'none_work_rai', 'none_work_ngan', 'none_work_wah',
                                    'edu_level', 'curr_institution', 'curr_field', 'grades', 'next_institution', 'next_field',
                                    'app_status', 'father_full_name', 'father_age', 'father_occupation', 'father_workplace', 'father_phone',
                                    'mother_full_name', 'mother_age', 'mother_occupation', 'mother_workplace', 'mother_phone',
                                    'parent_status', 'parent_status_1', 'parent_status_2', 'parent_status_3', 'parent_status_4',
                                    'contactable', 'relationship_to_applicant', 'total_siblings', 'working_siblings',
                                    'siblings_in_school', 'unemployed_siblings', 'siblings_not_of_age', 'family_income_per_year',
                                    'provider_full_name', 'provider_relationship', 'doitung_activities', 'school_activities', 'other_activities',
                                    'applicant_proj_no', 'father_proj_no', 'mother_proj_no', 'father_rights4',
                                    'rights_father_no', 'rights_father_job_title', 'rights_father_department', 'rights_father_years',
                                    'mother_rights4', 'rights_mother_no', 'rights_mother_job_title', 'rights_mother_department', 'rights_mother_years',
                                    'is_linegroup', 'filename', 'original_name', 'path', 'extension', 'mimetype', 'size'
                                ];

                                // 2. สร้าง FormData object
                                const formData = new FormData();

                                // 3. Append ทุกฟิลด์จาก this.state ตามลำดับใน keys
                                keys.forEach(key => {
                                    formData.append(key, this.state[key]);
                                });

                                // 4. รอ 100 มิลลิวินาที (delay)
                                await delay(100);

                                // 5. แปลง base64 image เป็น Blob
                                const base64Data = this.state.croppedImage.split(',')[1];
                                const mimeType = this.state.croppedImage.split(';')[0].split(':')[1];
                                const imageBlob = await this.base64ToBlob(base64Data, mimeType);

                                // 6. Append image Blob ไปที่ formData
                                formData.append('image', imageBlob, 'image.png');

                                // 7. รออีก 100 มิลลิวินาที (delay)
                                await delay(100);

                                // 8. ส่ง POST request พร้อม formData และ headers (auth)
                                const response = await axios.post(
                                    `${process.env.REACT_APP_API}/application`,
                                    formData,
                                    this.state.authHeader
                                );

                                // 9. รออีก 100 มิลลิวินาที (delay)
                                await delay(100);

                                // 10. ดึงข้อมูลผลลัพธ์จาก response
                                const data = response.data;

                                if (data.message === 'successfully') {

                                    const messageResponse = await axios.post(`${process.env.REACT_APP_API}/messages`, {
                                        message: `มีผู้สมัครขอรับทุนการศึกษาใหม่!\n👤 ชื่อ: ${this.state.first_name} ${this.state.last_name} (${this.state.nickname})\n📞 เบอร์โทร: ${this.state.phone}\n🏫 สถานศึกษาที่จะเรียนต่อ: ${this.state.next_institution}\n🔍 ตรวจสอบข้อมูลเพิ่มเติม: 👉 https://applyscholarship.maefahluang.org/admin/applicant/detail/${response.data.data.id}`
                                    });

                                    if (messageResponse.data.message === 'successfully') {

                                        await this.onRead({ mode: 'read' })

                                        await delay(100);

                                        await this.promisedSetState({ loading: false })

                                        Swal.fire({
                                            title: "คุณได้ยื่นสมัครขอรับทุนการศึกษาเรียบร้อยแล้ว",
                                            html: `<div style="font-size: 1.2rem">กรุณาตรวจสอบสถานะและรายละเอียดเพิ่มเติมได้ในหน้าประวัติส่วนตัว</div>`,
                                            icon: "success",
                                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                                            allowOutsideClick: false, // กำหนดไม่ให้ปิด Swal โดยคลิกนอก
                                        }).then(async (result) => {
                                            if (result.isConfirmed) {
                                                // รอให้ onForms ทำงานเสร็จหลังผู้ใช้กดตกลง
                                                await this.onForms({ mode: 'read', step: 0 });
                                            }
                                        });
                                    }
                                }
                            } catch (error) {
                                console.error('Error submitting application:', error);
                            }
                        } else {
                            Swal.fire({
                                title: "ระบบปิดรับสมัคร",
                                icon: "error",
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            });
                        }
                    }

                } else if (this.state.is_linegroup === false) {
                    Swal.fire({
                        title: "กรุณาเข้ากลุ่ม Line",
                        icon: "warning",
                        timer: 2000,
                        timerProgressBar: true,
                        confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                    });
                }
                break;
            default:
                console.error(`Unknown step: ${step}`);
                return; // If the step doesn't match, exit the function
        }
    }

    onPrevious = async step => {
        this.onForms({ mode: 'read', step: step - 1 })
    }

    onEdit = async ({ mode, id, reload }) => {
        if (mode === 'update') {
            await this.promisedSetState({ loading: true })

            const updateState = async (data) => {
                await this.promisedSetState({
                    update_prefix: data.prefix || this.state.update_prefix,
                    update_first_name: data.first_name || this.state.update_first_name,
                    update_last_name: data.last_name || this.state.update_last_name,
                    update_date_of_birth: data.date_of_birth || this.state.update_date_of_birth,
                    update_house_number: data.house_number || this.state.update_house_number,
                    update_village_no: data.village_no || this.state.update_village_no,
                    update_village: data.village || this.state.update_village,
                    update_village_name: data.village_name || this.state.update_village_name,
                    update_province: data.province || this.state.update_province,
                    update_province_id: data.province_id || this.state.update_province_id,
                    update_amphur: data.amphur || this.state.update_amphur,
                    update_amphur_id: data.amphur_id || this.state.update_amphur_id,
                    update_tambon: data.tambon || this.state.update_tambon,
                    update_tambon_id: data.tambon_id || this.state.update_tambon_id,
                    update_phone: data.phone || this.state.update_phone
                });
            };

            const fetchData = async (provinceId, amphurId) => {
                await this.fetchProvinces();
                await this.fetchAmphures('update_amphures', 'update_tambons', provinceId);
                await this.fetchTambons('update_tambons', amphurId);
                await this.fetchVillages();
            };

            if (reload === true) {
                await updateState(this.state);
                await fetchData(this.state.update_province_id, this.state.update_amphur_id);
            } else if (reload === false) {
                const response = await axios.get(`${process.env.REACT_APP_API}/applicants/${id}`, this.state.authHeader);
                const data = response.data[0];
                await updateState(data);
                await fetchData(data.province_id, data.amphur_id);
            }

            await this.promisedSetState({
                modal: <Modal size={'md'}
                    backdrop={'static'}
                    open={true}
                    onClose={() => this.setState({ modal: null })}
                >
                    <Modal.Header>
                        <b>แก้ไขข้อมูลสมาชิก</b>
                    </Modal.Header>
                    <Modal.Body>
                        <Container>
                            <Row>
                                <Col>
                                    <VStack>
                                        <label>1. คำนำหน้า <span style={{ color: 'red' }}>*</span></label>
                                        <SelectPicker
                                            className='C75Pq'
                                            size='lg'
                                            data={[
                                                { value: 'นาย', label: 'นาย' },
                                                { value: 'นางสาว', label: 'นางสาว' }
                                            ]}
                                            searchable={false}
                                            style={{ width: 180 }}
                                            placeholder="กรุณาเลือกรายการ"
                                            defaultValue={this.state.update_prefix}
                                            onChange={e => this.setState({ update_prefix: e })}
                                            onClean={() => this.setState({ update_prefix: '' })}
                                        />
                                    </VStack>
                                </Col>
                            </Row>
                            <Row className='mt-3'>
                                <Col>
                                    <VStack>
                                        <label>2. ชื่อ <span style={{ color: 'red' }}>*</span></label>
                                        <Input
                                            className='T7LM3'
                                            size='sm'
                                            defaultValue={this.state.update_first_name}
                                            onChange={e => this.setState({ update_first_name: e })} />
                                    </VStack>
                                </Col>
                            </Row>
                            <Row className='mt-3'>
                                <Col>
                                    <VStack>
                                        <label>3. นามสกุล <span style={{ color: 'red' }}>*</span></label>
                                        <Input
                                            className='t3XjX'
                                            size='sm'
                                            defaultValue={this.state.update_last_name}
                                            onChange={e => this.setState({ update_last_name: e })} />
                                    </VStack>
                                </Col>
                            </Row>
                            <Row className='mt-3'>
                                <Col>
                                    <VStack>
                                        <label>4. วัน/เดือน/ปี เกิด <span style={{ color: 'red' }}>*</span></label>
                                        <div className='C5kQ9' style={{ display: 'flex', alignItems: 'center' }}>
                                            <ThaiDatePicker
                                                placeholder="วัน/เดือน/ปี พ.ศ."
                                                value={this.state.update_date_of_birth}
                                                inputProps={{
                                                    style: {
                                                        padding: '6px 8px',
                                                        borderRadius: '6px 0 0 6px',
                                                        border: '1px solid #E7E5E4',
                                                        width: '200px',
                                                    }
                                                }}
                                                onChange={async (e) => {
                                                    await this.promisedSetState({ update_date_of_birth: e });
                                                    this.onEdit({ mode, id, reload: true })
                                                }}
                                                onClean={async () => {
                                                    await this.promisedSetState({ update_date_of_birth: '' });
                                                    this.onEdit({ mode, id, reload: true })
                                                }}
                                            />
                                            <IconButton
                                                icon={<i className="bi bi-calendar3"></i>}
                                                size="md"
                                                style={{
                                                    borderRadius: '0 6px 6px 0', // top-left 0, top-right 6px, bottom-right 6px, bottom-left 0
                                                }}
                                            />
                                        </div>
                                    </VStack>
                                </Col>
                            </Row>
                            <Row className='mt-3'>
                                <label className='mb-2'>5. ที่อยู่ตามทะเบียนบ้าน <span style={{ color: 'red' }}>*</span></label>
                                <Stack wrap spacing={10}>
                                    <VStack>
                                        <label>บ้านเลขที่</label>
                                        <Input
                                            className='6LG4x'
                                            size='sm'
                                            style={{ width: 90 }}
                                            aria-label="บ้านเลขที่"
                                            defaultValue={this.state.update_house_number}
                                            onChange={e => this.setState({ update_house_number: e })} />
                                    </VStack>
                                    <VStack>
                                        <label>หมู่ที่</label>
                                        <Input
                                            className='6HAar'
                                            size='sm'
                                            style={{ width: 60 }}
                                            aria-label="หมู่ที่"
                                            defaultValue={this.state.update_village_no}
                                            onChange={e => this.setState({ update_village_no: e })} />
                                    </VStack>
                                    <VStack>
                                        <label>หมู่บ้าน</label>
                                        <SelectPicker
                                            className='Db9oU'
                                            size='lg'
                                            placeholder='กรุณาเลือก'
                                            data={this.state.villages}
                                            style={{ width: 200 }}
                                            defaultValue={this.state.update_village}
                                            onChange={async e => {
                                                await this.promisedSetState({ update_village: e })
                                                await this.onEdit({ mode: mode, id: id, reload: true })
                                            }}
                                            onClean={async e => {
                                                await this.promisedSetState({ update_village: '' })
                                                await this.onEdit({ mode: mode, id: id, reload: true })
                                            }}
                                        />
                                    </VStack>
                                    {this.state.update_village === 'other' && (
                                        <VStack>
                                            <label>โปรดระบุ (ชื่อหมู่บ้าน)</label>
                                            <Input
                                                className='u2hN6'
                                                size='sm'
                                                style={{ width: 200 }}
                                                defaultValue={this.state.update_village_name}
                                                onChange={e => this.setState({ update_village_name: e })}
                                            />
                                        </VStack>
                                    )}
                                    <VStack>
                                        <label>จังหวัด</label>
                                        <SelectPicker
                                            className='Vz670'
                                            size='lg'
                                            placeholder='กรุณาเลือก'
                                            data={this.state.update_provinces}
                                            style={{ width: 200 }}
                                            defaultValue={this.state.update_province_id}
                                            onSelect={async (v, i) => {
                                                await this.promisedSetState({ update_province: i.label, update_province_id: i.value })
                                                await this.handleProvinceChange({
                                                    value: i.value,
                                                    mode: 'update',
                                                    amphureKey: 'update_amphures',
                                                    tambonKey: 'update_amphurs',
                                                    id: id
                                                })
                                            }}
                                            onClean={() => this.setState({ update_province: '', update_province_id: 0 })}
                                        />
                                    </VStack>
                                    <VStack>
                                        <label>อำเภอ</label>
                                        <SelectPicker
                                            className='CY9Uc'
                                            size='lg'
                                            placeholder='กรุณาเลือก'
                                            data={this.state.update_amphures}
                                            style={{ width: 200 }}
                                            defaultValue={this.state.update_amphur_id}
                                            onSelect={async (v, i) => {
                                                await this.promisedSetState({ update_amphur: i.label, update_amphur_id: i.value })
                                                await this.handleAmphureChange({
                                                    value: i.value,
                                                    mode: 'update',
                                                    tambonKey: 'update_tambons',
                                                    id: id
                                                })
                                            }}
                                            onClean={() => this.setState({ update_amphur: '', update_amphur_id: 0 })}
                                        />
                                    </VStack>
                                    <VStack>
                                        <label>ตำบล</label>
                                        <SelectPicker
                                            className='PAzpy'
                                            size='lg'
                                            placeholder='กรุณาเลือก'
                                            data={this.state.update_tambons}
                                            style={{ width: 200 }}
                                            defaultValue={this.state.update_tambon_id}
                                            onSelect={async (v, i) => await this.promisedSetState({ update_tambon: i.label, update_tambon_id: i.value })}
                                            onClean={() => this.setState({ update_tambon: '', update_tambon_id: 0 })}
                                        />
                                    </VStack>
                                </Stack>
                            </Row>
                            <Row className='mt-3'>
                                <Col>
                                    <VStack>
                                        <label>6. เบอร์โทรศัพท์ติดต่อ <span style={{ color: 'red' }}>*</span></label>
                                        <Input
                                            className='FnA6A'
                                            size='sm'
                                            aria-label="เบอร์โทรศัพท์"
                                            defaultValue={this.state.update_phone}
                                            onChange={e => this.setState({ update_phone: e })}
                                            onClean={() => this.setState({ update_phone: '' })}
                                        />
                                    </VStack>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer className='p-2'>
                        <Button
                            appearance="primary"
                            startIcon={<i className="bi bi-floppy"></i>}
                            onClick={() => this.onConfirm({ mode: 'update', id })}
                        >
                            บันทึก
                        </Button>
                        <Button
                            onClick={() => this.setState({ modal: null })}
                            appearance="subtle">
                            ยกเลิก
                        </Button>
                    </Modal.Footer>
                </Modal>
            })

            await this.promisedSetState({ loading: false })
        }
    }

    formatDateOfBirth(dateOfBirth) {
        const date = new Date(dateOfBirth);

        // Thai locale options for formatting
        const options = {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
        };

        // Format the date using Thai locale
        const formattedDate = new Intl.DateTimeFormat('th-TH', options).format(date);

        // Convert the year to Buddhist Era (BE), which is 543 years ahead of the Gregorian calendar
        const buddhistYear = date.getFullYear() + 543;

        // Replace the Gregorian year with the Buddhist Era year in the formatted date
        const finalDate = formattedDate.replace(date.getFullYear(), buddhistYear);

        return finalDate;
    }

    calculateAge = (date_of_birth) => {
        const birthDate = new Date(date_of_birth);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const month = today.getMonth() - birthDate.getMonth();

        if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    }

    formatBaht(income) {
        // Convert the number to a formatted string with commas and two decimal places
        return income.toLocaleString('th-TH', {
            minimumFractionDigits: 2,  // Ensures two decimal places
            maximumFractionDigits: 2   // Limits to two decimal places
        });
    }

    onDetail = async ({ mode, id }) => {
        if (mode === 'read') {
            await this.promisedSetState({ loading: true })

            if (this.state.existing) {

                const responseApplicant = await axios.get(`${process.env.REACT_APP_API}/application/${id}`, this.state.authHeader);
                const data = responseApplicant.data[0]

                await this.promisedSetState({
                    content: <Container>
                        <Navbar className='shadow-sm mb-3'>
                            <Nav>
                                <Nav.Item
                                    icon={<i className="bi bi-list"></i>}
                                    onClick={() => this.onMenus({ mode: 'open' })}
                                >
                                    <Text weight='bold'>เมนู</Text>
                                </Nav.Item>
                            </Nav>
                            <Nav pullRight>
                                <Nav.Item>
                                    <HStack spacing={'6px'}>
                                        <i className="bi bi-person-circle"></i>
                                        {`${this.state.login_first_name} ${this.state.login_last_name}`}
                                    </HStack>
                                </Nav.Item>
                            </Nav>
                        </Navbar>
                        <Row>
                            <Col className='text-center'>
                                <Text weight="bold">
                                    {`ประวัติของผู้สมัคร`}
                                </Text>
                            </Col>
                        </Row>

                        <Row className="justify-content-center mt-3">
                            <Col md={12} lg={12}>
                                <Card border="light" className='shadow-sm'>
                                    <Card.Header className='text-white' style={{ backgroundColor: '#8a0a0a' }}></Card.Header>
                                    <div style={{ padding: '1em' }}>
                                        <div>
                                            <Images
                                                src={`${process.env.REACT_APP_UPLOAD}/${data.path}`}
                                                rounded
                                                style={{ width: '2.5cm', height: '3.5cm' }}
                                            />
                                        </div>

                                        <div style={{ marginTop: '1em' }}><span><b>ข้อมูลทั่วไป</b></span></div>

                                        <div><span>1. เลขบัตรประชาชน: </span><span>{data.id_card_number}</span></div>
                                        <div><span>2. ชื่อ-สกุล: </span><span>{`${data.first_name} ${data.last_name}`}</span></div>
                                        <div><span>3. ชื่อเล่น: </span><span>{data.nickname}</span></div>
                                        <div>
                                            <span>4. ชนเผ่า: </span>
                                            <span>
                                                {data.ethnicity === 'อื่นๆ'
                                                    ? data.ethnicity_other
                                                    : data.ethnicity}
                                            </span>
                                        </div>
                                        <div>
                                            <span>5. วัน/เดือน/ปี เกิด: </span><span>{this.formatDateOfBirth(data.date_of_birth)}</span>
                                            <span style={{ paddingLeft: '1em' }}>อายุ: </span><span>{this.calculateAge(data.date_of_birth)} ปี</span>
                                        </div>
                                        <div><span>6. ที่อยู่ตามทะเบียนบ้าน: </span><span>{
                                            data.reg_province_id === 1
                                                ? (
                                                    <>
                                                        บ้านเลขที่ {data.reg_house_number}{' '}
                                                        หมู่ที่ {data.reg_village_no}{' '}
                                                        หมู่บ้าน {data.reg_village === 'other' ? data.reg_village_name : data.reg_village}{' '}
                                                        {data.reg_tambon}{' '}
                                                        {data.reg_amphur}{' '}
                                                        {data.reg_province}{' '}
                                                    </>
                                                )
                                                : (
                                                    <>
                                                        บ้านเลขที่ {data.reg_house_number}{' '}
                                                        หมู่ที่ {data.reg_village_no}{' '}
                                                        หมู่บ้าน {data.reg_village === 'other' ? data.reg_village_name : data.reg_village}{' '}
                                                        ต.{data.reg_tambon}{' '}
                                                        อ.{data.reg_amphur}{' '}
                                                        จ.{data.reg_province}{' '}
                                                    </>
                                                )
                                        }</span></div>
                                        <div><span>7. ที่อยู่จริงในปัจจุบัน: </span><span>{data.is_reg_address === 'yes' ? 'ใช่' :
                                            (
                                                <>
                                                    บ้านเลขที่ {data.temp_house_number}{' '}
                                                    หมู่ที่ {data.temp_village_no}{' '}
                                                    หมู่บ้าน {data.temp_village === 'other' ? data.temp_village_name : data.temp_village}{' '}
                                                    ต.{data.temp_tambon}{' '}
                                                    อ.{data.temp_amphur}{' '}
                                                    จ.{data.temp_province}{' '}
                                                </>
                                            )}</span></div>
                                        <div><span>8. โทรศัพท์ติดต่อส่วนตัวของผู้สมัครขอรับทุน: </span><span>{data.phone}</span></div>
                                        <div><span>9. ที่อยู่ (บ้าน/ที่อยู่อาศัย) ของครอบครัว: </span>
                                            {data.is_family_residence === 'yes' ? <span>มีบ้าน/ที่อยู่อาศัยเป็นของครอบครัว จำนวน {data.family_residence_rai} ไร่ {data.family_residence_ngan} งาน {data.family_residence_wah} ตารางวา</span>
                                                : <span>ไม่มีบ้าน/ที่อยู่อาศัยของครอบครัว</span>}
                                        </div>
                                        <div><span>10. ที่ทำกินของครอบครัว: </span>
                                            {data.is_family_work === 'yes' ? <span>มีที่ทำกินเป็นของครอบครัว จำนวน {data.family_work_rai} ไร่ {data.family_work_ngan} งาน {data.family_work_wah} ตารางวา</span>
                                                : <span>ไม่มีที่ทำกินของครอบครัว</span>}
                                        </div>
                                        <div><span>11. ที่อยู่ (บ้าน/ที่อยู่อาศัย) นอกพื้นที่: </span>
                                            {data.is_none_residence === 'yes' ? <span>มีบ้าน/ที่อยู่อาศัยเป็นนอกพื้นที่ จำนวน {data.none_residence_rai} ไร่ {data.none_residence_ngan} งาน {data.none_residence_wah} ตารางวา</span>
                                                : <span>ไม่มีบ้าน/ที่อยู่อาศัยนอกพื้นที่</span>}
                                        </div>
                                        <div><span>12. ที่ทำกินนอกพื้นที่: </span>
                                            {data.is_none_work === 'yes' ? <span>มีที่ทำกินนอกพื้นที่ จำนวน {data.none_work_rai} ไร่ {data.none_work_ngan} งาน {data.none_work_wah} ตารางวา</span>
                                                : <span>ไม่มีที่ทำกินนอกพื้นที่</span>}
                                        </div>

                                        <div style={{ marginTop: '1em' }}><span><b>ข้อมูลการเรียน</b></span></div>

                                        <div><span>1. ระดับการศึกษาที่ศึกษาอยู่: </span><span>{data.edu_level}</span></div>
                                        <div><span>2. สถานศึกษา ณ ปัจจุบัน: </span><span>{data.curr_institution}</span></div>
                                        <div><span>3. สาย/สาขา วิชา: </span><span>{data.curr_field}</span></div>
                                        <div><span>4. ผลการเรียนเฉลี่ยรวม (5 ภาคเรียนหรือเทอมล่าสุด): </span><span>{data.grades}</span></div>
                                        <div><span>5. สถานศึกษาที่จะเรียนต่อ: </span><span>{data.next_institution}</span></div>
                                        <div><span>6. สาย/สาขาที่จะเรียนต่อ: </span><span>{data.next_field}</span></div>
                                        <div><span>7. สถานะการสมัครเรียนในมหาวิทยาลัย: </span><span>{data.app_status}</span></div>

                                        <div style={{ marginTop: '1em' }}><span><b>ข้อมูลครอบครัว</b></span></div>

                                        <div><span>1. ชื่อ - สกุล บิดา (ผู้ให้กำเนิด): </span><span>{data.father_full_name}</span></div>
                                        <div><span>2. อายุบิดา: </span><span>{data.father_age} ปี</span></div>
                                        <div><span>3. อาชีพของบิดา: </span><span>{data.father_occupation}</span></div>
                                        <div><span>4. สถานที่ทำงานของบิดา: </span><span>{data.father_workplace}</span></div>
                                        <div><span>5. หมายเลขโทรศัพท์ของบิดา: </span><span>{data.father_phone}</span></div>
                                        <div><span>6. ชื่อ-สกุล มารดา (ผู้ให้กำเนิด): </span><span>{data.mother_full_name}</span></div>
                                        <div><span>7. อายุมารดา: </span><span>{data.mother_age} ปี</span></div>
                                        <div><span>8. อาชีพของมารดา: </span><span>{data.mother_occupation}</span></div>
                                        <div><span>9. สถานที่ทำงานของมารดา: </span><span>{data.mother_workplace}</span></div>
                                        <div><span>10. หมายเลขโทรศัพท์ของมารดา: </span><span>{data.mother_phone}</span></div>
                                        <div><span>11. สถานะของบิดา มารดา: </span><span>{data.parent_status}</span></div>
                                        <div><span>12. ผู้ปกครองที่สามารถติดต่อได้: {data.contactable} ความเกี่ยวข้องกับผู้สมัคร: {data.relationship_to_applicant}</span></div>
                                        <div><span>13. จำนวนพี่น้องร่วมบิดามารดา: (ไม่รวมผู้สมัคร) {data.total_siblings} คน</span></div>
                                        <div><span>14. จำนวนพี่น้องที่ทำงานแล้ว: {data.working_siblings} คน</span></div>
                                        <div><span>16. จำนวนพี่น้องที่ว่างงาน: {data.unemployed_siblings} คน</span></div>
                                        <div><span>17. จำนวนพี่น้องที่ยังไม่ถึงวัยเรียน: {data.siblings_not_of_age} คน</span></div>
                                        <div><span>18. รายได้รวมต่อปีของครอบครัว (รวมรายได้ของบิดา/มารดา/พี่น้องที่ทำงานแล้ว): {this.formatBaht(data.family_income_per_year)} บาท/ปี</span></div>
                                        <div><span>19. ผู้ที่สนับสนุนค่าใช้จ่ายในชีวิตประจำวัน/ค่าใช้จ่ายในการเรียนของผู้สมัคร</span></div>
                                        <div><span style={{ paddingLeft: '1em' }}>ชื่อ-สกุล: {data.provider_full_name}</span></div>
                                        <div><span style={{ paddingLeft: '1em' }}>ความเกี่ยวข้องกับผู้สมัคร: {data.provider_relationship}</span></div>

                                        <div style={{ marginTop: '1em' }}><span><b>ข้อมูลด้านการเข้าร่วมกิจกรรม</b></span></div>

                                        <div><span>1. กิจกรรมที่เคยเข้าร่วมของมูลนิธิแม่ฟ้าหลวง ในพระบรมราชูปถัมภ์/โครงการพัฒนาดอยตุงฯ: {data.doitung_activities}</span></div>
                                        <div><span>2. กิจกรรมที่เคยเข้าร่วมของโรงเรียน: {data.school_activities}</span></div>
                                        <div><span>3. กิจกรรมที่อื่นๆ ที่เคยเข้าร่วม: {data.other_activities}</span></div>

                                        <div style={{ marginTop: '1em' }}><span><b>ข้อมูลที่กรอกเพิ่มเติมเฉพาะตามสิทธิ์</b></span></div>

                                        {data.rights1 && (<><div><span>สิทธิ์ที่ 1 </span><span>เป็นเยาวชนที่อาศัยอยู่ในพื้นที่โครงการพัฒนาดอยตุงฯ</span></div>
                                            <div style={{ marginLeft: '2em' }}><span>1. เลข คพต.พ ของผู้สมัคร: </span><span>{data.applicant_proj_no}</span></div>
                                            <div style={{ marginLeft: '2em' }}><span>2. เลข คพต.พ ของบิดา: </span><span>{data.father_proj_no}</span></div>
                                            <div style={{ marginLeft: '2em' }}><span>3. เลข คพต.พ ของมารดา: </span><span>{data.mother_proj_no}</span></div></>)}
                                        {data.rights2 && (<><div><span>สิทธิ์ที่ 2 </span><span>เป็นเยาวชนที่อาศัยอยู่ในพื้นที่โครงการขยายผลของมูลนิธิแม่ฟ้าหลวง พระบรมราชูปถัมภ์</span></div></>)}
                                        {data.rights3 && (<><div><span>สิทธิ์ที่ 3 </span><span>เป็นเยาวชนที่กำลังศึกษาระดับชั้นมัธยมศึกษาปีที่ 6 ในโรงเรียนบ้านห้วยไร่สามัคคี</span></div></>)}
                                        {data.rights4 && (<><div><span>สิทธิ์ที่ 4 </span><span>เป็นบุตรพนักงานมูลนิธิแม่ฟ้าหลวงฯ (เป็นพนักงานปัจจุบัน)</span></div>
                                            <div style={{ marginLeft: '2em' }}><span>รายละเอียดบุคคลที่ทำงานในมูลนิธิแม่ฟ้าหลวงฯ</span></div>
                                            <div style={{ marginLeft: '2em' }}><span>บิดา รหัสพนักงาน: {data.rights_father_no} ตำแหน่งงาน: {data.rights_father_job_title}</span></div>
                                            <div style={{ marginLeft: '2em' }}><span>ส่วนงาน/แผนก: {data.rights_father_department} จำนวนปีที่ทำงานในมูลนิธิฯ: {data.rights_father_years}</span></div>
                                            <div style={{ marginLeft: '2em' }}><span>มารดา รหัสพนักงาน: {data.rights_mother_no} ตำแหน่งงาน: {data.rights_mother_job_title}</span></div>
                                            <div style={{ marginLeft: '2em' }}><span>ส่วนงาน/แผนก: {data.rights_mother_department} จำนวนปีที่ทำงานในมูลนิธิฯ: {data.rights_mother_job_title}</span></div></>)}
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                        <br />
                    </Container>
                })

                await this.promisedSetState({ loading: false })

            } else {

                await this.promisedSetState({ loading: false })

                Swal.fire({
                    title: "กรุณากรอกข้อมูลประวัติให้ครบถ้วน",
                    icon: "warning",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });
            }
        }
    }

    // Convert toggleVisibility to an arrow function to bind it to the class instance
    toggleVisibility = async (field) => {
        await this.promisedSetState((prevState) => ({
            passwordVisibility: {
                ...prevState.passwordVisibility,
                [field]: !prevState.passwordVisibility[field]
            }
        }));
    };

    // Generic handler for input changes
    handleInputChange = async (field) => (e) => {
        this.promisedSetState({ [field]: e });
    };

    onPassword = async ({ mode, id }) => {
        if (mode === 'update') {
            await this.promisedSetState({ loading: true })

            await this.promisedSetState({
                modal: <Modal size={'sm'}
                    backdrop={'static'}
                    open={true}
                    onClose={() => this.setState({ modal: null })}
                >
                    <Modal.Header>
                        <b>เปลี่ยนรหัสผ่าน</b>
                    </Modal.Header>
                    <Modal.Body>
                        <Container>
                            <Row className='mb-2'>
                                <Col>
                                    <VStack>
                                        <label>Password เดิม</label>
                                        <InputGroup size='lg' inside style={{ width: '100%' }}>
                                            <Input
                                                className='M09oA'
                                                type={this.state.passwordVisibility.old_password ? 'text' : 'password'}
                                                defaultValue={this.state.old_password}
                                                onChange={e => this.setState({ old_password: e })} />
                                            <InputGroup.Button onClick={async () => {
                                                await this.toggleVisibility('old_password')
                                                await this.onPassword({ mode, id })
                                            }}>
                                                {this.state.passwordVisibility.old_password ? <i className="bi bi-eye"></i> : <i className="bi bi-eye-slash"></i>}
                                            </InputGroup.Button>
                                        </InputGroup>
                                    </VStack>
                                </Col>
                            </Row>

                            <Row className='mb-2'>
                                <Col>
                                    <VStack>
                                        <label>Password ใหม่</label>
                                        <InputGroup size='lg' inside style={{ width: '100%' }}>
                                            <Input
                                                className='GYtnp'
                                                type={this.state.passwordVisibility.new_password ? 'text' : 'password'}
                                                defaultValue={this.state.new_password}
                                                onChange={e => this.setState({ new_password: e })} />
                                            <InputGroup.Button onClick={async () => {
                                                await this.toggleVisibility('new_password')
                                                await this.onPassword({ mode, id })
                                            }}>
                                                {this.state.passwordVisibility.new_password ? <i className="bi bi-eye"></i> : <i className="bi bi-eye-slash"></i>}
                                            </InputGroup.Button>
                                        </InputGroup>
                                    </VStack>
                                </Col>
                            </Row>

                            <Row className='mb-2'>
                                <Col>
                                    <VStack>
                                        <label>Password ใหม่อีกครั้ง</label>
                                        <InputGroup size='lg' inside style={{ width: '100%' }}>
                                            <Input
                                                className='PSFgq'
                                                type={this.state.passwordVisibility.confirm_password ? 'text' : 'password'}
                                                defaultValue={this.state.confirm_password}
                                                onChange={e => this.setState({ confirm_password: e })} />
                                            <InputGroup.Button onClick={async () => {
                                                await this.toggleVisibility('confirm_password')
                                                await this.onPassword({ mode, id })
                                            }}>
                                                {this.state.passwordVisibility.confirm_password ? <i className="bi bi-eye"></i> : <i className="bi bi-eye-slash"></i>}
                                            </InputGroup.Button>
                                        </InputGroup>
                                    </VStack>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm>
                                    <Text color="red">- รหัสผ่านประกอบด้วยตัวอักษรภาษาอังกฤษ ตัวเลข และสัญลักษณ์เท่านั้น</Text>
                                    <Text color="red">- รหัสผ่านต้องมีความยาวระหว่าง 6 ถึง 18 ตัวอักษร</Text>
                                    <Text color="red">- รหัสผ่านต้องมีหมายเลขอย่างน้อยหนึ่งตัว</Text>
                                    <Text color="red">- รหัสผ่านต้องมีสัญลักษณ์อย่างน้อยหนึ่งตัว</Text>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer className='p-2'>
                        <Button
                            appearance="primary"
                            startIcon={<i className="bi bi-floppy"></i>}
                            onClick={() => this.onConfirm({ mode: 'password', id })}
                        >
                            บันทึก
                        </Button>
                        <Button
                            onClick={() => this.setState({ modal: null })}
                            appearance="subtle">
                            ยกเลิก
                        </Button>
                    </Modal.Footer>
                </Modal>
            })

            await this.promisedSetState({ loading: false })
        }
    }

    validatePassword = (password) => {
        const minLength = 6;
        const maxLength = 18;
        const hasNumber = /\d/;
        const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/;
        const isEnglishOnly = /^[A-Za-z0-9!@#$%^&*(),.?":{}|<>]+$/;

        if (password.length < minLength || password.length > maxLength) {
            return { valid: false, message: "รหัสผ่านต้องมีความยาวระหว่าง 6 ถึง 18 ตัวอักษร" };
        }
        if (!hasNumber.test(password)) {
            return { valid: false, message: "รหัสผ่านต้องมีหมายเลข\nอย่างน้อยหนึ่งตัว" };
        }
        if (!hasSymbol.test(password)) {
            return { valid: false, message: "รหัสผ่านต้องมีสัญลักษณ์\nอย่างน้อยหนึ่งตัว" };
        }
        if (!isEnglishOnly.test(password)) {
            return { valid: false, message: "รหัสผ่านสามารถประกอบด้วย\nตัวอักษรภาษาอังกฤษ ตัวเลข และสัญลักษณ์เท่านั้น" };
        }
        return { valid: true };
    };

    onConfirm = async ({ mode, id }) => {
        if (mode === 'update') {
            const validateInfo = async () => {
                const validationPromises = [
                    this.Validate(this.state.update_prefix, 'C75Pq', ''),
                    this.Validate(this.state.update_first_name, 'T7LM3', ''),
                    this.Validate(this.state.update_last_name, 't3XjX', ''),
                    this.Validate(this.state.update_date_of_birth, 'C5kQ9', ''),
                    this.Validate(this.state.update_house_number, '6LG4x', ''),
                    this.Validate(this.state.update_village_no, '6HAar', ''),
                    this.Validate(this.state.update_village, 'Db9oU', null),
                    ...(this.state.village === 'other' ? [
                        this.Validate(this.state.update_village_name, 'u2hN6', ''),
                    ] : []),
                    this.Validate(this.state.update_province, 'Vz670', ''),
                    this.Validate(this.state.update_amphur, 'CY9Uc', ''),
                    this.Validate(this.state.update_tambon, 'PAzpy', ''),
                    this.Validate(this.state.update_phone, 'FnA6A', ''),
                ];

                const validationResults = await Promise.all(validationPromises);
                return validationResults.every(result => result === true);
            };

            if (await validateInfo()) {
                const Response = await axios.put(`${process.env.REACT_APP_API}/applicants/update`, {
                    id
                    , prefix: this.state.update_prefix
                    , first_name: this.state.update_first_name
                    , last_name: this.state.update_last_name
                    , date_of_birth: this.state.update_date_of_birth
                    , house_number: this.state.update_house_number
                    , village_no: this.state.update_village_no
                    , village: this.state.update_village
                    , village_name: this.state.update_village_name
                    , province: this.state.update_province
                    , province_id: this.state.update_province_id
                    , amphur: this.state.update_amphur
                    , amphur_id: this.state.update_amphur_id
                    , tambon: this.state.update_tambon
                    , tambon_id: this.state.update_tambon_id
                    , phone: this.state.update_phone
                }, this.state.authHeader);

                const data = Response.data;

                if (data.message === 'successfully') {

                    await this.promisedSetState({ modal: null })

                    Swal.fire({
                        title: "คุณแก้ไขข้อมูลเรียบร้อยแล้ว",
                        icon: "success",
                        timer: 2000,
                        timerProgressBar: true,
                        confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                    });
                }
            }
        } else if (mode === 'password') {
            const validateInfo = async () => {
                const validationPromises = [
                    this.Validate(this.state.old_password, 'M09oA', ''),
                    this.Validate(this.state.new_password, 'GYtnp', ''),
                    this.Validate(this.state.confirm_password, 'PSFgq', '')
                ];

                const validationResults = await Promise.all(validationPromises);
                return validationResults.every(result => result === true);
            };

            if (await validateInfo()) {

                await this.promisedSetState({ loading: true })

                const Response = await axios.post(`${process.env.REACT_APP_API}/applicants/password`, {
                    id: id
                    , password: this.state.old_password
                }, this.state.authHeader);

                const data = Response.data;

                if (data.message === 'successfully') {
                    try {
                        this.checkpass = true;
                        const passwordValidation = this.validatePassword(this.state.new_password);
                        if (!passwordValidation.valid) {

                            await this.promisedSetState({ loading: false })

                            $('.GYtnp').addClass("required");
                            Swal.fire({
                                title: passwordValidation.message,
                                icon: "warning",
                                timer: 2000,
                                timerProgressBar: true,
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            });
                            this.checkpass = false;
                        } else {
                            $('.GYtnp').removeClass("required");
                        }

                        if (this.state.new_password !== this.state.confirm_password) {

                            await this.promisedSetState({ loading: false })

                            $('.PSFgq').addClass("required");
                            Swal.fire({
                                title: "รหัสผ่านไม่ตรงกัน",
                                icon: "warning",
                                timer: 2000,
                                timerProgressBar: true,
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            });
                            this.checkpass = false;
                        } else {
                            $('.PSFgq').removeClass("required");
                        }

                        if (this.checkpass === true) {

                            const Response = await axios.put(`${process.env.REACT_APP_API}/applicants/password`, {
                                id: id
                                , password: this.state.new_password
                            }, this.state.authHeader);

                            const data = Response.data;

                            if (data.message === 'successfully') {

                                await this.promisedSetState({ loading: false, modal: [] })

                                Swal.fire({
                                    title: "เปลี่ยนรหัสผ่านเรียบร้อยแล้ว",
                                    icon: "success",
                                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`
                                }).then(() => {
                                    // Redirect to form_apply page after alert is closed
                                    window.location.href = '/';
                                });
                            }
                        }
                    } catch (error) {
                        if (error.response?.status === 401) {
                            window.location.href = '/';
                        } else {
                            // จัดการ error อื่น ๆ ตามปกติ
                            Swal.fire({
                                title: 'เกิดข้อผิดพลาด',
                                text: error.response?.data?.message || 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
                                icon: 'error',
                                confirmButtonText: 'ตกลง'
                            });
                        }
                    }

                } else if (data.message === 'incorrect_password') {

                    await this.promisedSetState({ loading: false })

                    Swal.fire({
                        title: "รหัสผ่านเดิมไม่ถูกต้อง<br>กรุณาตรวจสอบและลองใหม่อีกครั้ง",
                        icon: "warning",
                        timer: 2000,
                        timerProgressBar: true,
                        confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                    });
                }
            }
        }
    }

    render() {

        const FullPageLoader = () => (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999 // Ensure it's on top of other content
            }}>
                <Loader content="Loading..." /> {/* Adjust loader component as needed */}
            </div>
        );

        return (
            <>
                {this.state.menus}
                {this.state.content}
                {this.state.modal}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}
